import React, { useEffect, useState } from "react";
import Axios from "axios";
import "./styles.scss";
import { useHistory } from "react-router-dom";
import { enterpriseSupportEmail } from "../../config/legalEmails";

const HorizonMasterContract = () => {
  const [setLoading] = useState(false);
  const [setResponse] = useState([]);
  const history = useHistory();
  const [licenseType, setLicenseType] = useState();

  useEffect(() => {
    history.location.pathname.indexOf("android")
      ? setLicenseType("android")
      : setLicenseType("ios");
  }, [history.location.pathname]);

  useEffect(() => {
    // getLicenseInfo();
  }, []);

  return (
    <div
      className="tnc-jioimmerse-wrapper"
      spellCheck="false"
      tabIndex={0}
      contentEditable="false"
    >
      <div className="tnc-jioimmerse-wrapper-info">
        <h3 id="tnc-jioimmerse-wrapper-inner">
          <u>Tesseract Customer Terms</u>
        </h3>
      </div>
      <div className="">
        {/* <h3 id="tnc-jioimmerse-wrapper-inner"> */}
        In terms of this Master Customer Agreement (“<strong>Agreement</strong>”), <strong>Tesseract
        Imaging Limited</strong>, a company incorporated under the Companies Act, 2013
        with its registered office at 16 Chittaranjan Tower CTS No 104 A 4 2 of, Tirandaz Village Powai, Near Hiranandani Hospital, Mumbai, Maharashtra, India, 400076 (also referred to as <strong>“Tesseract”</strong>,
          <strong>“we”</strong>, or <strong>“us”</strong>, which expression shall unless it be repugnant to the
        context or meaning thereof, mean and include its affiliates, successors
        and assigns) is: (a) offering access to the Software (defined below),
        Services (defined below) and Additional Services (defined below) to the
        <strong>Customer</strong> (i.e. a legal entity incorporated under applicable laws in
        India or in any other country, if applicable) (also referred to as <strong>“you”</strong>
        which expression shall unless it be repugnant to the context or meaning
        thereof, mean and include its affiliates, successors and permitted
        assigns); and (b) facilitating access to the Hardware (defined below) of
        its affiliates to the Customer subject to the terms of this Agreement.
        By accepting this Agreement below or by providing a written acceptance
        of the business proposal of Tesseract for placing an order (<strong>“Order”</strong>) to
        Tesseract or by using the Software, Services, Additional Services or
        Hardware in any manner, you and the entity you represent and any
        affiliate of such entity included in the scope of your use of the
        Software, Services, Additional Services and/ or Hardware, agree that you
        have the authority to bind Customer to this Agreement and have read,
        understand and agree to be bound by this Agreement to the exclusion of
        all other terms. If the terms of this Agreement are considered an offer,
        acceptance is expressly limited to such terms. This Agreement is entered
        into as of the date you accept this Agreement or place an Order or use
        the Software, Services, Additional Services and/ or Hardware, whichever
        is earlier (<strong>“Effective Date”</strong>).
        <br></br>
        <br></br>
        In addition to the terms under this Agreement, Tesseract or its
        affiliates may present additional terms and conditions when an Order is
        placed with Tesseract. The personnel of the Customer, who places the
        Order with Tesseract, represents that he or she is authorized to enter
        into this Agreement on behalf of the Customer. If you are not so
        authorized, or if you disagree with any of the terms of this Agreement
        including any additional terms and conditions as presented by Tesseract
        or its affiliates, you must not access the Hardware or use any of the
        Services or Additional Services provided in connection with / under this
        Agreement. You acknowledge and agree that Tesseract reserves the right
        to change, modify, add or remove portions of this Agreement at its sole
        discretion. Tesseract shall notify Customers in case of any
        updates/changes. Upon such notification, Customers are required to read,
        understand, acknowledge and accept the updated terms of the Agreement in
        the manner stipulated by Tesseract. Subsequent to such acceptance,
        Tesseract will proceed to grant access to the Services and Additional
        Services in strict accordance with the revised terms of the Agreement.
        <br></br>
        <br></br>
        Notwithstanding your initial acceptance of the Agreement, you must
        re-accept all updated versions of the Agreement from time to time, as
        and when you are notified of the same by Tesseract for continued access
        to the Services and Additional Services. Each time you place an Order
        with Tesseract / use a Service and/ or Additional Service under this
        Agreement, you represent to Tesseract that you have accepted the then
        current version of the Agreement. Notwithstanding anything contained
        herein, your obligations under this Clause shall be the essence of this
        Agreement, and you shall indemnify, defend, and hold Tesseract harmless
        from any claim, loss, damage, liability, inconvenience, or costs
        (including without limitation attorneys’ fees) arising from or in
        connection with your breach of this Clause.
        <br></br>
        <br></br>
        Tesseract may choose to provide and/or facilitate (as may be applicable)
        only: (a) licenses for Software; or (b) licenses to Services or any part
        of Services; or (c) Additional Services; or (d) Hardware as may be
        provided by Tesseract or its affiliates, and the Customer may opt not to
        obtain either the: (a) licenses to the Software and/ or Services and/ or
        any part of the Services; (b) Additional Services; or (c) Hardware as
        may be provided by Tesseract or its affiliates. In such an event,
        Customers shall be entitled to use the licensed Software, Services,
        Additional Services and/ or Hardware, in accordance with this Agreement
        or any other terms and conditions as may be provided to you by Tesseract
        or its affiliates. It is further stated that Tesseract reserves the sole
        right to set distinct pricing and usage terms for each of the offerings
        i.e., Software, Services, Additional Services and Hardware. Tesseract
        retains the right to modify, alter, or discontinue the individual
        purchase option for either Software, Services or Additional Services at
        its sole discretion.
        <br></br>
        <br></br>
        The Agreement consists of the following components:
      </div>

      {/* <ul className="tnc-jioimmerse-wrapper-ul_style">
        <li role="presentation">
          <strong>1. SCOPE&nbsp;</strong>
        </li>
      </ul> */}
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.&nbsp;</li>
        <li>
          <u>
            <strong>Master Terms </strong>
          </u>
          – Applicable in all cases to the extent the same is not in conflict or
          inconsistent with the specific terms under the Services Specific
          Terms, Hardware Specific Terms, Additional Services Terms (as provided
          below). It is hereby clarified that in the event of such conflict, the
          specific terms as may be applicable to specific use of the Services,
          Hardware and Additional Service shall take precedence to the extent
          required to remove such inconsistency or conflict, as the case may be.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">2&nbsp;</li>
        <li>
          <u>
            <strong> Services Specific Terms </strong>
          </u>
          - Applicable to your commercial and non-commercial use of Tesseract’s
          software, platform, server services and cloud services.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">3&nbsp;</li>
        <li>
          <u>
            <strong> Hardware Specific Terms </strong>
          </u>
          - Applicable to your purchase and/or lease of Tesseract and/ or its
          affiliates devices, e. g. virtual reality, augmented reality and mixed
          reality glasses.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">4&nbsp;</li>
        <li>
          <u>
            <strong> Additional Services Terms </strong>
          </u>
          - Applicable to your purchase of additional services from Tesseract,
          e.g., content development, configuration, customizations, integration,
          consulting, support and training.
        </li>
      </ul>

      <ul className="tnc-jioimmerse-wrapper-ul_style">
        <li role="presentation">
          <strong>A. Master Terms </strong>
        </li>
      </ul>

      <ul className="tnc-jioimmerse-wrapper-content">
        {/* <li role="presentation">2.1&nbsp;</li> */}
        <li>
          The terms and conditions listed below in these Master Terms shall
          apply with respect to all your contractual relationships with
          Tesseract in relation to the Services/Hardware and/or Additional
          Services provided under this Agreement.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.1&nbsp;</li>
        <li>
          <strong>Fees and Prices</strong>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.1.1&nbsp;</li>
        <li>
          Customer shall pay Tesseract the price specified separately to the
          Customer for access to the Services, Additional Services and Hardware
          (<strong>“Fees”</strong>). Unless otherwise agreed in writing, all
          fees and charges shall be due immediately upon invoicing and in the
          currency specified in the Order agreed by the Customer. The invoiced
          amounts shall be paid as per the payment methods communicated by
          Tesseract during the process of placing the Order. Customer
          acknowledges and agrees that payment may be collected and processed by
          Tesseract and/ or its affiliates, as the case maybe.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.1.2&nbsp;</li>
        <li>
          In addition to the terms under this Agreement, Fees, License Quantity
          Limits (<i>as defined below</i>), and other such commercial terms with
          regard to the Services, Additional Services and Hardware, any other
          commercial terms (<i>as stated herein</i>) shall be separately agreed
          by and between the Customer and Tesseract in writing by way of a
          binding quotation/proposal, order document or sales order, as the case
          maybe.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.1.3&nbsp;</li>
        <li>
          <strong>Invoicing </strong>
          <br></br>
          Unless otherwise specified in the Order, Tesseract and/ or its
          affiliates shall invoice the respective Fee:
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">(i)&nbsp;</li>
            <li>
              for the Subscription of the License at the date of the Order, and,
              if applicable, subsequently at the beginning of each Renewal Term;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">(ii)&nbsp;</li>
            <li>
              for the Additional Services (a) upfront in case of Bundled Package
              (refer Clause 5.1 of Section D (Additional Services Specific
              Terms)) or Cost Estimate (refer Clause 5.2 of Section D
              (Additional Services Specific Terms)) or (b) in all other cases,
              on a monthly basis after the Additional Services have been
              performed (including in case of time and material basis);
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">(iii)&nbsp;</li>
            <li>
              for Hardware Purchase/ Hardware Lease upfront at the date of the
              Order (unless otherwise specified to the Customer while placing of
              the Order by the Customer for the Hardware Purchase/ Hardware
              Lease). It is hereby clarified that invoicing for Hardware
              Purchase/ Hardware License under this Clause shall be the sole
              responsibility of the respective affiliate of Tesseract providing
              the Hardware, with Tesseract holding no liability in this regard;
              and
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">(iv)&nbsp;</li>
            <li>
              for the Extra License Fees immediately upon the Customer exceeding
              the License Quantity Limits.
            </li>
          </ul>
          <br></br>
          The invoicing shall be made either (a) online via an email to the
          email address provided by the Customer; or (b) if an account has been
          created within the Software – by uploading onto the Customer’s account
          created or by sending a notification to the Customer via email. The
          Customer shall only be entitled to the delivery of a physical invoice
          by mail (registered or otherwise) if the Customer requests such
          physical invoice from Tesseract in writing and pays the additional
          fees for the same as may be required.
        </li>
      </ul>

      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.1.4&nbsp;</li>
        <li>
          <strong>Prices, fees, and tax</strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              The Fees and charges specified in the Order do not include any
              sales, transfer, goods, services, value-added, or similar
              gross-receipts-based tax (including applicable withholding tax,
              which shall be added to the invoiced amount, if applicable).
              Customer is responsible for the payment of any and all such
              applicable taxes. Any bank processing charges shall be additional
              and shall be solely borne by the Customer.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.1.5&nbsp;</li>
        <li>
          <strong>Price increase</strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Unless otherwise specified in the Order, Tesseract may notify
              Customer of a price increase at least thirty (30) days prior to
              the expiry of the current Subscription Period (refer Clause 1.11
              of Section A (<i>Master Terms</i>). If no objection is made by the
              Customer within seven (7) days of such notification, the price
              increase will go into effect upon the commencement of the Renewal
              Term. Tesseract shall inform the Customer in its notification
              about this effect of non-objection. If Customer objects to the
              price increase, the parties shall in good faith attempt to resolve
              the matter amicably within seven (7) days of intimation by the
              Customer to Tesseract of an objection to such price increase. If
              the price increase is subsequently agreed to by the Customer, the
              same shall be applicable from the commencement of the Renewal
              Term. If no mutual consensus is reached, the Agreement and/or the
              Order shall stand terminated at the end of the current
              Subscription Period as per clause 1.11.1 of Section A (
              <i>Master Terms</i>).
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.1.6&nbsp;</li>
        <li>
          <strong>Late Payment </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Any overdue payment shall accrue interest or penalty (as the case
              may be) at the rate provided by Tesseract at its sole discretion (
              <strong>"Interest”</strong>) . In addition to the Interest above,
              the following provisions shall also apply:
              <ul className="tnc-jioimmerse-wrapper-content">
                <li role="presentation">(i)&nbsp;</li>
                <li>
                  <li>
                    Reminder fee: It is agreed that after the issuance of two
                    (2) consecutive reminders (where the second reminder to the
                    Customer shall be issued forty-eight (48) hours after
                    issuance of the first reminder) for payment, Tesseract shall
                    be entitled to charge such amounts as may be agreed between
                    the parties under an Order.
                  </li>
                </li>
              </ul>
              <ul className="tnc-jioimmerse-wrapper-content">
                <li role="presentation">(ii)&nbsp;</li>
                <li>
                  <li>
                    Termination in case of default of payment of Fee: In
                    addition to the rights available with Tesseract under Clause
                    1.1.6(iii), Tesseract may terminate the Order and this
                    Agreement if the Customer defaults on the payment of the Fee
                    and fails to cure the breach within seven (7) days of
                    receiving notice from Tesseract on such default of payment
                    of Fee. Termination is in addition to (and not in lieu of)
                    any other rights and remedies available to Tesseract
                    hereunder, at equity or at law.{" "}
                  </li>
                </li>
              </ul>
              <ul className="tnc-jioimmerse-wrapper-content">
                <li role="presentation">(iiI)&nbsp;</li>
                <li>
                  <li>
                    Suspension in case of default of payment of Fee: If the
                    Customer defaults on the payment of the Fees, Tesseract, in
                    addition to the rights available with Tesseract under Clause
                    1.1.6(ii), shall also be entitled to suspend the Services
                    and/ or the Additional Services temporarily (“Suspension”).
                    However, Tesseract shall notify the Customer of the
                    Suspension with a three (3) days’ advance notice, via email
                    or in-app notifications within the Software. Any such
                    Suspension under this Clause shall be rescinded by Tesseract
                    without undue delay once the Customer has cleared his due
                    payment of Fees (including any reminder fee or interest) in
                    full. During the Suspension, the Software would be disabled
                    and no connections can be established from and to the
                    installations of the Third-party Software (as defined under
                    clause 2.4 of Section B (Services Specific Terms)). It is
                    further stated that access to and from the Third-party
                    Software, Software, Services, or systems will be temporarily
                    disabled until the outstanding Fees are fully paid by the
                    Customer. It is stated that Tesseract shall not be held
                    liable for any losses or damages incurred by the Customer
                    during the period of Suspension. The Customer’s obligation
                    to pay the Fees shall continue to be in effect during the
                    Suspension period and such Suspension will not absolve the
                    Customer of its financial obligations.
                  </li>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>

      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.2&nbsp;</li>
        <li>
          <strong>Confidentiality</strong>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.2.1&nbsp;</li>
        <li>
          <strong>Confidential Information. </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              “Confidential Information” is non-public information whether
              designated as “confidential” or whether in writing, orally, or in
              any other form or that a reasonable person should understand is
              confidential, including, but not limited to, the terms of this
              Agreement, and Customer’s account authentication credentials with
              respect to the Software. Confidential Information does not include
              information that (i) becomes publicly available without a breach
              of a confidentiality obligation; or (ii) the receiving party
              received lawfully from another source without a confidentiality
              obligation; or (iii) is independently developed by the Customer
              without use of the disclosing party’s Confidential Information; or
              (4) is a comment, feedback or suggestion that one party
              voluntarily provides about the other party’s business, products or
              services.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.2.2&nbsp;</li>
        <li>
          <strong>Protection of Confidential Information</strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Both Tesseract and Customer will take reasonable steps to protect
              the other party’s Confidential Information and will use the other
              party’s Confidential Information only for purposes captured under
              this Agreement. Neither party will disclose Confidential
              Information to third parties, except to its Representatives, and
              only: (a) on a need-to-know basis; or (b) in furtherance of
              providing the Services Additional Services and/ or Hardware
              Purchase/ Hardware Lease and fulfilment of its obligations under
              this Agreement (in case of Tesseract), under non-disclosure
              obligations at least as protective as the terms under this Clause.
              Each party remains responsible for the use of Confidential
              Information by its Representatives and, in the event of discovery
              of any unauthorized use or disclosure, must promptly notify the
              other party. “<strong>Representative</strong>” means the
              personnel, employees, officers, directors, legal representatives,
              agents, contractors, service providers, advisors and consultants
              (each acting in such respective capacity) of a party or its
              affiliates.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.2.3&nbsp;</li>
        <li>
          <strong>Disclosure required by law </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              A party may disclose the other’s Confidential Information if
              required by applicable law, but only after it notifies the other
              party (if legally permissible) to enable the other party to seek a
              protective order.
            </li>
          </ul>
        </li>
      </ul>

      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.2.4&nbsp;</li>
        <li>
          <strong>Return of Confidential Information </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Upon the expiration or termination of the Subscription Period
              (whichever is earlier), or at the disclosing party's request at
              any time during the Subscription, the receiving party and its
              Representatives shall (a) stop using the disclosing party’s
              Confidential Information, except as necessary to comply with
              applicable law, (b) promptly return to the disclosing party all
              copies of the Confidential Information, whether in written,
              electronic or other form or media, and (c) destroy all such copies
              and confirm the same in writing to the disclosing party. The
              parties hereby acknowledge and agree that: (1) any unauthorized
              disclosure or use of Confidential Information would cause
              irreparable harm; (2) monetary damages would be inadequate to
              compensate for such harm; and (3) the breach or threatened breach
              of this Agreement may entitle the parties to obtain specific
              performance and injunctive relief in addition to any other legal
              remedies that may be available.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.2.5&nbsp;</li>
        <li>
          <strong>Survival </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              The provisions of this Clause 1.2 shall continue to apply after
              expiration or termination of the Subscription (whichever is
              earlier), for a period of five (5) years or, in respect of any
              Confidential Information constituting a trade secret, for as long
              as such Confidential Information is protectable as a trade secret.
            </li>
          </ul>
        </li>
      </ul>

      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.3&nbsp;</li>
        <strong>Privacy </strong>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.3.1&nbsp;</li>
        Customer consents to the processing of Personal Data by Tesseract and/or
        its affiliates, and their respective agents and subcontractors for
        purposes of providing the access to Hardware, Services and Additional
        Services under this Agreement. Before providing Personal Data of third
        parties or Data Principal(s) (as defined below) to Tesseract, Customer
        will obtain all required consents from such third parties (including
        Customer’s contacts, partners, distributors, administrators, and
        employees) and Data Principal(s) under applicable privacy and Data
        Protection Laws. “Personal Data” means any information, as defined under
        Data Protection Laws, relating to an identified or identifiable natural
        person (“Data Principal”). An identifiable natural person is one who can
        be identified, directly or indirectly, in particular by referencing an
        identifier as defined under applicable law including but not limited to
        a name, an identification number, location data, an online identifier,
        or to one or more factors specific to the physical, physiological,
        genetic, mental, economic, cultural, or social identity of that natural
        person. “Data Protection Laws” means any and all laws applicable to data
        security, protection, privacy, or the processing of Personal Data.
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.3.2&nbsp;</li>
        <p>Tesseract’s practices in connection with collection, handling and use of
        Personal Data are governed by Tesseract’s Enterprise Suite privacy
        policy available at <a href="https://legal.jiorealityos.com/tesseract-enterprise/privacy-policy">https://legal.jiorealityos.com/tesseract-enterprise/privacy-policy</a> (for
        Tesseract Enterprise Suite) and Tesseract’s Horizons privacy policy
        available at <a href="https://legal.jiorealityos.com/horizons/privacy-policy">https://legal.jiorealityos.com/horizons/privacy-policy</a> (for
        Tesseract Horizons Portal) (“<strong>Privacy Policy</strong>”).
        </p>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.3.3&nbsp;</li>
        <li>
          <strong>Non-personal data</strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Tesseract may process non-personal or anonymous data to improve
              functionality and the Customers’ experience with the Services,
              Additional Services and provide access to the Hardware. Customer
              agrees that it shall provide Tesseract with all appropriate rights
              in and that Tesseract is free to use any such non-personal or
              anonymous data in any way it deems fit for development,
              diagnostic, corrective, security as well as marketing or any other
              purposes.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.4&nbsp;</li>
        <li>Customer Representations, Warranties and Covenants </li>
      </ul>

      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.4.1&nbsp;</li>

        <li>
          Customer represents, warrants and covenants to Tesseract that:
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">(a)&nbsp;&nbsp;</li>
            <li>
              it shall at all times comply with all applicable laws (including
              Data Protection Laws, anti-corruption laws and other laws
              prohibiting bribery, corruption, inaccurate books and records,
              inadequate internal controls, and money-laundering) in connection
              with purchase and use of Services, Additional Services and
              Hardware;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">(b)&nbsp;&nbsp;</li>
            <li>
              it shall at all times conduct its business activities with
              integrity and in a professional manner;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">(c)&nbsp;&nbsp;</li>
            <li>
              it shall pay Tesseract for all Orders it places with Tesseract in
              a timely manner as may be provided by Tesseract;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">(d)&nbsp;&nbsp;</li>
            <li>
              it shall furnish information required by Tesseract from time to
              time, for Tesseract to provide the Services, Additional Services,
              Hardware and comply with its reporting obligations to third party
              service providers or authorities under applicable law;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">(e)&nbsp;&nbsp;</li>
            <li>
              it shall not submit any false, incomplete, inaccurate or
              misleading information to Tesseract;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">(f)&nbsp;&nbsp;</li>
            <li>
              it shall at all times keep itself updated, accept and comply with
              the terms and conditions/ terms of use for Services available at
              https://legal.jiorealityos.com/tesseract-enterprise/terms-and-conditions
              (for Tesseract Enterprise Suite) and
              https://legal.jiorealityos.com/horizons/terms-of-service (for
              Tesseract Horizons Portal);
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">(g)&nbsp;&nbsp;</li>
            <li>
              it shall comply with the terms of this Agreement at all times;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">(h)&nbsp;&nbsp;</li>
            <li>
              it shall not indulge in any form of counterfeiting, theft, piracy,
              unauthorized access, or infringement of intellectual property
              rights of Tesseract, or of its affiliates, or licensors;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">(i)&nbsp;&nbsp;</li>
            <li>
              it shall at all times maintain qualifying base licenses, necessary
              for installation of Services and the Hardware, for which Tesseract
              requires Customer to have such qualifying base licenses;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">(j)&nbsp;&nbsp;</li>
            <li>
              it has and shall have properly obtained all prerequisite
              infrastructure (including quantities thereto);
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">(k)&nbsp;&nbsp;</li>
            <li>
              the Application created is in compliance with all applicable laws
              and is not in contravention of any of the terms under this
              Agreement;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">(l)&nbsp;&nbsp;</li>
            <li>
              the Software provided under the License has been downloaded by the
              Customer in accordance with this Agreement and only for the
              purposes of its internal business requirements of the Customer;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">(m)&nbsp;&nbsp;</li>
            <li>
              it has evaluated all the risks associated with the use and License
              and accept the entire risk associated with such use and License;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">(n)&nbsp;&nbsp;</li>
            <li>
              all data made available or provided by the Customer to Tesseract
              in connection with use of the Services or otherwise during the
              term of the Subscription, is in strict compliance with all
              applicable Data Protection Laws;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">(o)&nbsp;&nbsp;</li>
            <li>
              it has not infringed and shall not infringe upon the intellectual
              property rights of any third parties in direct or indirect
              connection with the use of the Services, Additional Services or
              any of its constituents;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">(p)&nbsp;&nbsp;</li>
            <li>
              it shall not use the Services, Additional Services and/ or
              Hardware in such a way that would cause any portion of the
              Services (including Software, SDK and Development Tools),
              Additional Services and/ or Hardware to be subject to ownership
              and/or any licensing terms of any third party including any FOSS
              licensing terms or obligations. “FOSS” means any software that:
              (a) contains, or is derived in any manner (in whole or in part)
              from, any software that is distributed as free software, open
              source software, shareware, or similar licensing or distribution
              models; and (b) is subject to terms or any agreement with terms
              requiring that such software or software code be (i) disclosed or
              distributed in source code form or object code form, (ii) licensed
              for the purpose of making derivative works, and/or (iii)
              redistributable without consideration;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">(q)&nbsp;&nbsp;</li>
            <li>
              the use of Services, Additional Services and/ or Hardware by the
              Customer will not include any malware, malicious or harmful code,
              program, or other internal component (e.g., computer viruses,
              Trojan horses, “backdoors”) which could damage, destroy, or
              adversely affect the Services, Additional Services and/or Hardware
              or any other software, firmware, hardware, data, systems,
              services, or networks operated by Tesseract;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">(r)&nbsp;&nbsp;</li>
            <li>
              it shall instruct the Authorised Users permitted to use the
              Services of the obligations and prohibitions in this Agreement;
              and
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">(s)&nbsp;&nbsp;</li>
            <li>
              it shall not use the Development Tools in any manner that could
              impair, dilute, or tend to impair or adversely affect the
              reputation and relationship of Tesseract with third parties.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.5&nbsp;</li>
        <li>
          <strong>Customer Obligations </strong>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.5.1&nbsp;</li>
        <li>
          Lawful use – Customer shall use the Hardware, Services and Additional
          Services only in accordance with the provisions of this Agreement and
          in accordance with laws and regulations applicable to such use,
          including all Data Protection Laws and export control provisions and
          shall not infringe any third-party rights in connection with such use.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.5.2&nbsp;</li>
        <li>
          Prohibited Use – Any use of Hardware, Services and/or Additional
          Services for purposes that is not expressly authorized by Tesseract to
          the Customer is prohibited. In particular, the Customer shall not and
          shall not allow a third party to: (i) attempt to circumvent any
          technical component of the Hardware, Services and Additional Services
          that are directed at, or have the effect of, enforcing this Agreement;
          (ii) modify, create derivative works (except for creation of
          Application solely for the purposes of its own internal business
          activities as authorized under Clause 1.1.3 of Section B (Services
          Specific Terms), translate, decompile, disassemble or create or
          attempt to create, by reverse engineering or otherwise, the Hardware
          or the source code or the object code of the Services, or any updates
          or part thereof; (iii) use the Services, Additional Services and/ or
          the Hardware under any circumstance whatsoever directly or indirectly
          in a service bureau or in a rental or commercial timesharing
          arrangement or as a spyware; (iv) use the Hardware, Services and/ or
          Additional Services in order to (a) build a competitive product or
          service, (b) build a product using similar ideas, features, functions
          or graphics of the Hardware, Services and Additional Services, or (c)
          copy any ideas, features, functions or graphics of the Hardware,
          Services and Additional Services; (v) remove, modify or obscure any
          copyright, trade secret, confidentiality, trademark, service mark or
          other proprietary rights, serial number, notice, legend or similar on
          any copy of the Hardware, Services and Additional Services, or related
          data, manuals, documentation or other materials; (vi) license,
          sub-license, market, sell, resell, transfer, assign, lend, rent,
          lease, or otherwise distribute, the Hardware, Services and/ or
          Additional Services or provide access to Hardware, Services and/ or
          Additional Services to third parties (unless otherwise expressly
          allowed); (vii) license, sublicense, sell, resell, transfer, assign,
          distribute or otherwise commercially exploit or make available to any
          third party, any application, content or software including the
          Application developed using the Development Tools, in any way, unless
          otherwise expressly agreed in writing by Tesseract; (viii) use the
          Services and/ or Additional Services on any device that you do not own
          or control, and to distribute or make the Services and/ or Additional
          Services available over a network where it could be used by multiple
          devices at the same time (unless otherwise expressly allowed); (ix)
          engage in any act that Tesseract deems to be in conflict with the
          spirit or intent of the Services and Additional Services including
          without limitation, using cheats, exploits, automation software, bots,
          hacks, mods or any unauthorised third party software designed to
          modify or interfere with the Services and Additional Services; or (x)
          use the Hardware, Services and/ or Additional Services for any
          illegal, immoral or offensive purposes.{" "}
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.5.3&nbsp;</li>
        <li>
          Restrictions and obligations -– Except as expressly permitted in this
          Agreement, Customer must not:{" "}
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">(a)&nbsp;</li>
            <li>
              install or use any other third-party software or technology in any
              way that would subject Tesseract’s intellectual property or
              technology to any other license terms or cause the portions of the
              Services or Additional Services to be subject to any free and
              open-source software licensing terms or obligations.{" "}
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">(b)&nbsp;</li>
            <li>
              work around any technical limitations in Services or the
              Additional Services or restrictions in technical documentation.{" "}
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">(c)&nbsp;</li>
            <li>
              separate and run parts of Services or Additional Services on more
              than one device.{" "}
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">(d)&nbsp;</li>
            <li>
              upgrade or downgrade parts of Services or Additional Services at
              different times.{" "}
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">(e)&nbsp;</li>
            <li>
              Use unlicensed / pirated version of the Services or the Additional
              Services.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.5.4&nbsp;</li>
        <li>
          Customer must not use any of the Services and/or Additional Services
          or any part thereof in any manner that would:{" "}
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">(a)&nbsp;</li>
            <li>
              pose as a security risk to Tesseract, its affiliates or any third
              party;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">(b)&nbsp;</li>
            <li>adversely impact Tesseract’s other services and products;</li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">(c)&nbsp;</li>
            <li>subject Tesseract or its affiliates to any liability; or</li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">(d)&nbsp;</li>
            <li>be fraudulent and in contravention of applicable law.</li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.6&nbsp;</li>
        <li>
          <strong>Intellectual Property Rights </strong>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.6.1&nbsp;</li>
        <li>
          Each party shall remain owner of the intellectual property rights that
          are owned or controlled by such party prior to entering into this
          Agreement.{" "}
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.6.2&nbsp;</li>
        <li>
          All intellectual property including, but not limited to, patents,
          trademarks, service marks, trade names and copyrights, and
          applications, licenses and rights with respect to the foregoing, and
          all trade secrets, including know-how, inventions, designs, processes,
          works of authorship, manuals, documentation, computer programs and
          technical data and information (whether registered or unregistered)
          and any applications or registrations for the protection of these
          rights and all renewals and extensions thereof existing in any part of
          the world whether now known or in the future created, either in
          relation to the Hardware, Services or Additional Services, shall be
          the property of Tesseract and/or its affiliates or such third party
          software providers, as the case may be. Nothing in the Agreement will
          operate to assign any rights, title or interest in such intellectual
          property to the Customer.{" "}
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.6.3&nbsp;</li>
        <li>
          The Customer shall exclusively own all rights to the Application
          developed solely for its internal purposes in accordance with Clause
          1.1.3 of Section B (Services Specific Terms). However, the parties
          mutually agree that the Customer shall have the exclusive right to
          utilize the Application solely for its internal business purposes, and
          any commercialization or monetization thereof shall require the prior
          written consent of Tesseract. It is further stated that any such usage
          of the Application under this Clause shall be in accordance with this
          Agreement and applicable law.{" "}
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.6.4&nbsp;</li>
        <li>
          It is mutually agreed between the parties that any other derivative
          work (except for the Application) resulting from the utilization of
          the Hardware or the Services shall be the sole property of Tesseract.
          The Customer explicitly acknowledges and agrees that it shall neither
          possess nor assert any claims, rights, or interests related to the
          intellectual property of such derivative works (other than the
          Application). It is explicitly established that the ownership of
          intellectual property rights pertaining to these derivative works
          (other than the Application) shall perpetually and unconditionally
          vest with Tesseract. However, in cases where, by operation of law,
          certain rights do not vest with Tesseract, the Customer shall acquire
          such rights and promptly vest them with Tesseract, ensuring
          Tesseract’s ownership to the fullest extent permitted by applicable
          law.{" "}
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.6.5&nbsp;</li>
        <li>
          For the purposes of clarification, it is hereby stated that Clause 6
          (Intellectual Property Rights; use right) of Section D (Additional
          Services Specific Terms) shall apply for purposes of intellectual
          property rights in relation to Additional Services.{" "}
        </li>
      </ul>

      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.7&nbsp;</li>
        <li>
          <strong>Use of marks</strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Nothing herein grants either Tesseract or Customer a right or
              license over the other party’s trademarks, provided that Tesseract
              shall have the right to use the Customer’s corporate name and logo
              for the purpose of identifying the Customer as Tesseract’s
              customer for business promotion.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.8&nbsp;</li>
        <li>
          Reservation of rights
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              As between Tesseract and Customer, Tesseract retains all right,
              title and interest in and to the Services (including any
              customization and release versions) and/or the Additional Services
              and in all copies, modifications and derivative works of the
              Services and/or the Additional Services including, without
              limitation, all rights to patent, copyright, trade secret,
              know-how, trademark and other proprietary or intellectual property
              rights, even if provided to or otherwise contributed by the
              Customer. The License granted shall not include any rights to the
              source code of the Services and/or the Additional Services. By
              virtue of receipt and usage of the Services, Customer does not
              gain any of the intellectual property including but not limited to
              copyrights, patents, trademarks, trade name in the Services.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.9&nbsp;</li>
        <li>
          Audit{" "}
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Tesseract reserves the right to conduct an audit to verify the
              Customer’s compliance with this Agreement, in the manner
              communicated by Tesseract to Customer at the time of such audit.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.10&nbsp;</li>
        <li>
          Indemnification{" "}
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Customer hereby agrees to indemnify, defend, and hold Tesseract,
              and its affiliates and Tesseract’s and its affiliates’ agents,
              officers, personnel, directors, consultants, representatives,
              employees, and assigns harmless from and against any and all
              Claims, losses, damages, liabilities and costs (including without
              limitation attorneys’ fees) arising from (i) Customer’s use or
              misuse of, or access to, the Services, Additional Services and
              Hardware; (ii) intentional acts or omissions, fraud, gross
              negligence, or wilful misconduct by the Customer; (iii) Customer’s
              violation of this Agreement and any other terms executed and
              effective between Customer and Tesseract and/or Tesseract’s
              affiliates with respect to the Services and Additional Services;
              (iv) infringement by the Customer or any third party using the
              account of the Customer, of any intellectual property or other
              right of any person or entity; (v) violation of applicable laws;
              and/or (vi) any claims or disputes between the Customer and any
              third party whose services or products the Customer may have
              accessed through the Services, Additional Services and Hardware
              including for any claims relating to non-payment and/or misuse of
              such third party products. Tesseract reserves the right to assume
              the exclusive defence and control of any matter otherwise subject
              to indemnification by the Customer, in which event the Customer
              will assist and cooperate with Tesseract in asserting any
              available defence.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.11&nbsp;</li>
        <li>
          Term and Termination{" "}
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">1.11.1&nbsp;</li>
            <li>
              Term, auto-renewal and ordinary termination of Subscription
              <ul className="tnc-jioimmerse-wrapper-content">
                <li>
                  Subject to Clause 1.1.5 of Section A (Master Terms) and unless
                  otherwise specified in the Order, the initial term of the
                  Agreement and License for Subscription shall be twelve (12)
                  months (“Initial Term”) and automatically renew for subsequent
                  periods of twelve (12) months (each a “Renewal Term”), unless
                  either party notifies the other party no less than thirty (30)
                  calendar days prior to the end of the Initial Term or any
                  Renewal Term that the Agreement and License shall not renew.
                  All references in this Agreement to “Subscription Period”
                  shall be deemed to mean and include the Initial Term and/or
                  the Renewal Terms, as appropriate.{" "}
                </li>
              </ul>
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">1.11.2&nbsp;</li>
            <li>
              Termination for cause
              <ul className="tnc-jioimmerse-wrapper-content">
                <li>
                  Without limiting other remedies it may have, Tesseract may
                  terminate this Agreement and the applicable Subscription for
                  Customer’s breach of the terms of this Agreement, if the
                  Customer fails to cure the breach within the thirty (30) days’
                  of Tesseract notifying the Customer of such breach. Upon such
                  termination, all discounts which were made applicable and
                  passed on by Tesseract to Customer since the inception of the
                  Order will become null and void and all amounts due under any
                  unpaid invoices (including discounts availed for prepaid
                  Subscription for Services and/or Additional Services, as the
                  case may be) shall become due and payable immediately. For
                  Services and Additional Services billed periodically based on
                  usage, Customer must immediately pay for any unpaid usage as
                  on the termination date under this Clause.
                </li>
              </ul>
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">1.11.3&nbsp;</li>
            <li>
              <strong>Termination for convenience:</strong> Either Tesseract or
              the Customer may terminate this Agreement and Customer’s
              Subscription without any cause by giving sixty (60) days’ written
              notice to the other party.
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">1.11.4&nbsp;</li>
            <li>
              Tesseract may temporarily suspend or disable a Customer’s
              Subscription, including on account of use by the Customer in
              excess of License Quantity Limits without having paid the
              corresponding Extra License Fees. It is further stated that access
              to and from the Customer's Software, Services, or systems will be
              temporarily disabled until the Extra License Fees are fully paid
              by the Customer. It is stated that Tesseract shall not be held
              liable for any losses or damages incurred by the Customer during
              such period of Suspension or disablement.
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">1.11.5&nbsp;</li>
            <li>
              Tesseract may permit certain third-party service providers to
              offer certain products and services to the Customers with respect
              to the Hardware, Services and Additional Services. Customers may,
              at their sole risk and expense, elect to avail such third-party
              product and services. You acknowledge and agree that the use of
              any services of third party service providers is governed by such
              third party’s terms of use, license agreement, privacy policy, or
              other such agreement. Tesseract explicitly disclaims any and all
              responsibility for any practices of any such third parties. Third
              party service providers of Tesseract may temporarily disable or
              cancel their products and services provided under this Agreement
              for legal or regulatory reasons or as otherwise permitted under
              the terms and conditions of such third-party service providers.
              Customer will notify Tesseract of such events of disablement/
              disruption in access to or use of the Hardware, Services or
              Additional Services (as the case may be) as soon as reasonably
              practicable. Notwithstanding the foregoing, the Customer shall
              comply with all payment related obligations and accordingly be
              liable to pay for any payment related commitments made by Customer
              to Tesseract.
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">1.11.6&nbsp;</li>
            <li>
              Consequences of termination - Upon termination, cancellation or
              expiration of the Subscription and the Agreement: (i) the granted
              License shall end forthwith, and Customer shall delete the
              Software and all associated Additional Services from its devices
              and refrain from any further use of the Hardware, Services and/or
              Additional Services; (ii) Customer shall no longer have access to
              the data of the Customer stored within the Software, the Tesseract
              platform account and the Tesseract platform console. Customer
              shall be solely responsible for exporting the data prior to the
              termination or expiration of the Subscription Period (whichever is
              earlier) and to store it for further use. Tesseract shall not be
              obligated to any further release of data and disclaims all
              liability in this regard; (iii) Tesseract’s right to use
              non-personal or anonymous data in accordance with the Privacy
              Policy shall survive the termination of the Agreement and remain
              unaffected. Personal Data provided by the Customer that is
              processed for the purposes of this Agreement shall be deleted in
              compliance with applicable law and the Privacy Policy, unless
              Tesseract is obligated by applicable law to store it.
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">1.11.7&nbsp;</li>
            <li>
              If any termination or cancellation of the Subscription and this
              Agreement is due to a Customer’s breach of this Agreement and/ or
              termination by the Customer for convenience, Tesseract will not
              provide any refund or be held liable in any manner in connection
              with cancellation and/ or termination of the Subscription,
              Services and Additional Services. Upon written request, Tesseract
              may, at its sole discretion, assist Customer with migration of its
              data at an additional charge, the details of which will be
              communicated to the Customer by Tesseract. The specific terms and
              conditions associated with data migration shall be mutually agreed
              upon by both parties before any commencement of migration
              activities under this Clause.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.12&nbsp;</li>
        <li>Limitation of Liability</li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.12.1&nbsp;</li>
        <li>
          TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, NOTWITHSTANDING
          ANYTHING TO THE CONTRARY CONTAINED IN THIS AGREEMENT, NEITHER
          TESSERACT AND ITS AFFILIATES NOR THE AGENTS, OFFICERS, PERSONNEL,
          DIRECTORS, CONSULTANTS, REPRESENTATIVES, EMPLOYEES, OR CONTRACTORS OF
          TESSERACT AND ITS AFFILIATES WILL BE LIABLE FOR ANY INDIRECT,
          CONSEQUENTIAL (INCLUDING WITHOUT LIMITATION, DAMAGES FOR BUSINESS
          INTERRUPTION, OR LOSS OF BUSINESS INFORMATION), SPECIAL, OR INCIDENTAL
          DAMAGES OR DAMAGES FOR LOSS OF PROFITS OR REVENUES ARISING IN
          CONNECTION WITH THIS AGREEMENT, SERVICES, ADDITIONAL SERVICES,
          HARDWARE, DELIVERABLES, HOTFIXES, PRODUCTS, OR ANY OTHER MATERIALS OR
          INFORMATION, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES OR IF
          SUCH POSSIBILITY WAS REASONABLY FORESEEABLE. IN ANY EVENT, WHATEVER
          THE LEGAL BASIS FOR CUSTOMER CLAIMS, TESSERACT’S TOTAL LIABILITY (AND
          THAT OF ITS AND ITS AFFILIATES’ AGENTS, OFFICERS, PERSONNEL,
          DIRECTORS, CONSULTANTS, REPRESENTATIVES, EMPLOYEES, SUPPLIERS,
          CONTRACTORS OR SUBCONTRACTORS) WILL BE LIMITED TO THE TOTAL AMOUNT
          THAT IS PAID TO TESSERACT BY CUSTOMER FOR THE SERVICES IN THE 3
          (THREE) MONTHS PRECEEDING THE DATE OF A CLAIM; (IT BEING CLEARLY
          UNDERSTOOD THAT SUCH AMOUNT REFERS TO ONLY THE SUM PAID TO TESSERACT
          FOR THE SERVICES AND NOT THE AMOUNT PAID BY CUSTOMER TO TESSERACT’S
          AFFILIATES FOR PROCUREMENT OF HARDWARE). IT IS FURTHER CLARIFIED THAT
          NOTWITHSTANDING ANYTHING CONTAINED HEREIN, TESSERACT’S TOTAL LIABILITY
          (AND THAT OF ITS AND ITS AFFILIATES’ AGENTS, OFFICERS, PERSONNEL,
          DIRECTORS, CONSULTANTS, REPRESENTATIVES, EMPLOYEES, SUPPLIERS,
          CONTRACTORS OR SUBCONTRACTORS) FOR THE ADDITIONAL SERVICES WILL BE
          LIMITED TO THE PRO RATED AMOUNT THAT IS PAID TO THE CUSTOMER BY
          TESSERACT UNDER CLAUSE 7.1 OF PART D (ADDITIONAL SERVICES SPECIFIC
          TERMS) OR THE TOTAL AMOUNT THAT IS PAID TO TESSERACT BY CUSTOMER FOR
          THE SERVICES IN THE 3 (THREE) MONTHS PRECEEDING THE DATE OF A CLAIM,
          WHICHEVER IS LESSER.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.12.2&nbsp;</li>
        <li>
          For the avoidance of doubt, Tesseract shall not be held liable for any
          loss, inconvenience, damage or expense that is not directly
          attributable to an act or omission of Tesseract or for any loss,
          inconvenience, damage or expense that does not arise out of
          Tesseract’s delivery and/or supply of Services and Additional Services
          hereunder and the Customer hereby releases Tesseract and waives its
          right to institute any proceedings or Claim against Tesseract in
          connection with any such loss, inconvenience, damage or expense. For
          purposes of this Agreement, “Claim” means an action, cause of action,
          suit or judicial claim brought by any third party.
          <br></br>
          <br></br>In no event will either party be liable for indirect,
          incidental, special, punitive, or consequential damages, or loss of
          use, loss of profits, or interruption of business, however caused or
          on any theory of liability even if advised of the possibility of such
          damages or if such possibility was reasonably foreseeable. Strict
          liability (liability without fault) for defects which already existed
          when the Agreement was concluded shall be excluded. In no event will
          either party be liable for indirect, incidental, special, punitive, or
          consequential damages, or loss of use, loss of profits, or
          interruption of business, however caused or on any theory of liability
          even if advised of the possibility of such damages or if such
          possibility was reasonably foreseeable. Strict liability (liability
          without fault) for defects which already existed when the Agreement
          was concluded shall be excluded.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.13&nbsp;</li>
        <li>
          Warranties; no guarantees
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Warranties in this Agreement refer to the description of remedies
              available (in accordance with and at the sole discretion of
              Tesseract) to Customer in case of non-performance or defective
              performance and shall not be construed as a guarantee that stands
              for strict liability without fault. A guarantee of Tesseract for
              quality or committed features in the meaning of preceding Clause
              shall only be taken as such if made by Tesseract in writing
              (including a signature by an authorised signatory) and labelled
              expressively as “guarantee”.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.14&nbsp;</li>
        <li>
          Disclaimer
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">1.14.1&nbsp;</li>
            <li>
              Tesseract may, but will have no obligation to, perform certain
              functions associated with the purchase, activation, support and
              management of Customer purchased Hardware, Services and/or
              Additional Services. The Customer shall co-operate with Tesseract,
              for the performance of such functions, as required by Tesseract
              from time to time. These Hardware, Services and Additional
              Services are provided on an “as-is” and “as available” basis, and
              Tesseract does not guarantee that the Hardware, Services and
              Additional Services will be free from any material faults,
              interruption or unavailability.
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">1.14.2&nbsp;</li>
            <li>
              TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, TESSERACT
              DISCLAIMS AND EXCLUDES, ON ITS BEHALF AND ON BEHALF OF ITS
              AFFILIATES, SUPPLIERS AND SUBCONTRACTORS, ALL REPRESENTATIONS,
              WARRANTIES, AND CONDITIONS WHETHER EXPRESS, IMPLIED OR STATUTORY,
              INCLUDING BUT NOT LIMITED TO REPRESENTATIONS, WARRANTIES, OR
              CONDITIONS OF TITLE, NON INFRINGEMENT, SATISFACTORY CONDITION,
              MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE, WITH RESPECT
              TO ANY SERVICES, ADDITIONAL SERVICES, DELIVERABLES, HOTFIXES,
              PRODUCTS, OR ANY OTHER MATERIALS OR INFORMATION.{" "}
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">1.14.3&nbsp;</li>
            <li>
              EXCEPT AS EXPRESSLY SET FORTH IN THIS AGREEMENT, TESSERACT DOES
              NOT MAKE ANY ADDITIONAL PROMISES, EITHER EXPRESS OR IMPLIED,
              REGARDING TESSERACT’S PERFORMANCE UNDER THIS AGREEMENT. THE
              HARDWARE IS PROVIDED BY THIRD PARTIES AND/OR TESSERACT’S
              AFFILIATES ON AN “AS-IS” AND “AS AVAILABLE” BASIS, AND TESSERACT
              DOES NOT GUARANTEE THAT THE HARDWARE WILL BE FREE OF ANY MATERIAL
              FAULTS, INTERRUPTION OR UNAVAILABILITY. THE SERVICES AND
              ADDITIONAL SERVICES ARE PROVIDED ON AN “AS-IS” AND “AS AVAILABLE”
              BASIS AND TESSERACT DOES NOT GUARANTEE THAT THE SERVICES AND
              ADDITIONAL SERVICES WILL BE FREE OF ANY MATERIAL FAULTS,
              INTERRUPTION OR UNAVAILABLITY.
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">1.14.4&nbsp;</li>
            <li>
              HIGH RISK USE WARNING. THE HARDWARE, SERVICES AND ADDITIONAL
              SERVICES ARE NOT DESIGNED OR INTENDED FOR HIGH RISK USE SCENARIOS
              WHERE FAILURE OR FAULT OF ANY KIND OF THE HARDWARE, SERVICES AND
              ADDITIONAL SERVICES COULD REASONABLY BE SEEN TO LEAD TO DEATH OR
              SERIOUS BODILY INJURY, OR TO SEVERE DAMAGE TO TANGIBLE OR
              INTANGIBLE PROPERTY OR THE ENVIRONMENT.
            </li>
          </ul>
        </li>
      </ul>

      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.15&nbsp;</li>
        <li>
          Non-solicitation
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              During the Subscription Period and for a period of 1 (one) year
              thereafter, the Customer shall not directly or indirectly solicit,
              hire, contract for services, or provide any compensation or
              remuneration of any kind to any person employed by Tesseract;
              provided however that this provision shall not restrict general
              advertisements of employment or the right of any employee to
              respond to such general advertisements.{" "}
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.16&nbsp;</li>
        <li>
          Removal of conflicts
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Any inconsistent or conflicting terms and conditions contained in
              any Order, purchase order or similar instrument shall be of no
              force or effect, unless Tesseract has explicitly approved such
              terms and conditions in writing. In addition to acknowledging and
              accepting this Agreement and the Hardware Terms, Customers may
              also choose to issue purchase orders (“PO”) in accordance with
              their standard business practices. It is clarified that any terms
              and conditions contained within such PO will not apply to
              Tesseract, unless we expressly approve such terms in writing. It
              is explicitly clarified that in the event of any conflict or
              inconsistencies between the terms of the PO and the terms of the
              Agreement and Hardware Terms with respect to the use of the
              Services and the Hardware (as may be applicable), the Agreement
              and the Hardware Terms shall take precedence and prevail over the
              terms of the PO unless explicitly agreed otherwise between the
              parties in writing.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.17&nbsp;</li>
        <li>
          Severability
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              If any provision of this Agreement is found partly or wholly
              invalid or unenforceable by a court of competent jurisdiction,
              such provision shall be ineffective to the extent of such
              prohibition or unenforceability without invalidating the remaining
              provisions of this Agreement which shall remain in full force and
              effect. The prohibited or unenforceable provision shall be
              substituted by mutual consultation and agreement of the parties,
              with a provision that most closely reflects the original intention
              of the parties to the extent permitted by the applicable law.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.18&nbsp;</li>
        <li>
          Waiver
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Failure by either party to require performance of any provision of
              this Agreement shall not affect such party’s rights to full
              performance thereof at any time thereafter. A waiver of any breach
              or default under this Agreement shall not constitute a waiver of
              any other subsequent breach or default. No waiver shall be
              effective unless in writing and duly executed by the parties or
              their authorized representatives.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.19&nbsp;</li>
        <li>
          Notices
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">1.19.1&nbsp;</li>
            <li>
              Notices must be in writing and will be treated as delivered on the
              date received at the address, date shown on the return receipt,
              email transmission date, or date on the courier or fax
              confirmation of delivery, as the case may be.
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">1.19.2&nbsp;</li>
            <li>
              Notices to Tesseract must be sent to the following address:
              Tesseract Imaging Limited (TC-22, Reliance Corporate Park,
              Ghansoli, Navi Mumbai 400 701) or by email to
              {enterpriseSupportEmail}.
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li role="presentation">1.19.3&nbsp;</li>
            <li>
              Notices to Customer will be sent to the individual at the address
              Customer identifies on its account on the Software as its contact
              for notices. Tesseract may send notices and other information to
              Customer by email or other electronic form as may be decided by
              Tesseract.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.20&nbsp;</li>
        <li>
          Documentation
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              User manuals and support and service level agreements (SLA) can be
              separately provided upon request. Any further languages may be
              offered by Tesseract upon separate written request. As between the
              parties, Tesseract retains all right, title and interest in and to
              such documentation and in all copies, modifications and derivative
              works thereof including, without limitation, all rights to patent,
              copyright, trade secret, know-how, trademark and other proprietary
              or intellectual property rights.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.21&nbsp;</li>
        <li>
          Force Majeure
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Neither Tesseract nor Customer shall be responsible to the other
              party for any delay, damage, or failure caused by a Force Majeure
              Event. If any Force Majeure Event delays performance, the affected
              party will promptly notify the other party and the time allowed
              for such performance will be extended for the length of the Force
              Majeure Event; provided, however, that the affected party will
              exercise reasonable commercial steps to minimize the delay.
              Notwithstanding the foregoing, if one or more Force Majeure Events
              results in a delay of more than 60 (sixty) consecutive days in the
              performance of the obligations of the affected party, the other
              party may terminate the Subscription and the Agreement without any
              further liability. A Force Majeure Event will not apply to a
              party’s indemnification or defence obligations or a party’s
              financial obligations under this Agreement. “Force Majeure Event”
              means any act of God, act of nature or the elements, pandemics,
              epidemics, governmental lockdown restrictions, terrorism,
              insurrection, revolution or civil strife, piracy, civil war or
              hostile action, labor strikes, acts of public enemies, change in
              central or state laws, rules and regulations of any governmental
              authorities having jurisdiction over the premises, acute and
              unusual labor, material, or equipment shortages, or any other
              causes beyond the control of either party.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.22&nbsp;</li>
        <li>
          Assignment
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              No rights, privileges, or obligations of the Customer under this
              Agreement may be assigned, transferred, or sub-contracted by the
              Customer without the prior written consent of Tesseract.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.23&nbsp;</li>
        <li>
          Governing law
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              This Agreement shall be governed by and construed in accordance
              with the laws of India. Subject to Clause 1.24 below, both parties
              agree to submit to the jurisdiction of courts of Mumbai, India.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.24&nbsp;</li>
        <li>
          Dispute Resolution
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Any disputes arising out of or in connection with this Agreement,
              shall be referred to and finally resolved by arbitration with seat
              in Mumbai, India in accordance with the Arbitration and
              Conciliation Act, 1996. The language of such arbitration shall be
              English and the tribunal shall consist of one (1) arbitrator
              mutually appointed by both Tesseract and Customer and the award of
              the arbitrator shall be final and binding on both Tesseract and
              Customer. Notwithstanding anything to the contrary, the parties
              may agree to conduct the arbitration proceedings virtually through
              such audio-visual means as may be mutually agreed upon by the
              parties.{" "}
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.25&nbsp;</li>
        <li>
          Relationship between parties
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              The parties agree that this Agreement have been entered into on a
              principal-to-principal basis and this Agreement does not create a
              joint venture or a principal-agent relationship between the
              parties.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.26&nbsp;</li>
        <li>
          Survival
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              This Clause 1.26 and the following provisions of this Agreement
              shall survive the expiry, cancellation or termination of the
              Subscription and the Agreement: (a) Clauses 1.4, 1.5.2, 1.5.3,
              1.5.4, 1.6, 1.2, 1.3, 1.7, 1.8, 1.10, 1.12, 1.14, 1.15, 1.16,
              1.17, 1.18, 1.19, 1.23 and 1.24 of Section A (Master Terms); (b)
              Clauses 3 and 6 of Section B (Services Specific Terms); (c) Clause
              1.2 of Section C (Hardware Specific Terms); and (d) Clauses 1.4,
              3.6 and 6 of Section D (Additional Services Specific Terms).
            </li>
          </ul>
        </li>
      </ul>

      <ul className="tnc-jioimmerse-wrapper-ul_style">
        <li role="presentation">
          <strong>
            B. <u>Services Specific Terms </u>
          </strong>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>
          The Services Specific Terms contain the terms and conditions that
          additionally apply to you for the: (i) access and to use of certain
          software provided by Tesseract for enterprise customers and/ or
          platform provided by Tesseract, whether installed on devices of the
          Customer or accessed online via web browser, and may also include any
          applications, addon components, customized settings and features,
          modifications and all updates and Release Versions (“<strong>Tesseract
            Software Suite</strong>”), (ii) access to and use of certain development tools,
          provided to the Customer, which includes identified software
          development kit and documentation (<strong>“SDK”</strong>), design (UI/UX) toolkits and
          documentation, testing tools and other resources (collectively
          referred to as the <strong>“Development Tools”</strong>) available at any platform/
          domain provided or notified by Tesseract from time to time (Tesseract
          Software Suite, SDK and Development Tools are collectively referred to
          as <strong>“Software”</strong>), (iii) access to and use of servers for the
          establishment of encrypted connections (handshake) and for the
          forwarding of data packets (routing) in connection with the use of the
          Software (<strong>“Server Services”</strong>), and (iv) access to and use of any
          further cloud-based services provided by Tesseract from time to time.
          The Software, Server Services and other cloud-based services provided
          by Tesseract are hereinafter collectively referred to as <strong>“Services”</strong>.
          <br></br>
          <br></br>
          <strong>Applicability</strong> - This Section B (Services Specific
          Terms) shall be applicable in cases where Services are subscribed,
          purchased or otherwise used by the Customer.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
      <li role="presentation"><strong>1. License</strong>&nbsp;</li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.1&nbsp;</li>
        <li>Scope of License </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.1.1&nbsp;</li>
        <li>
          The Customer shall acquire a license (based on term, usage, storage,
          subscription and/ or other parameters) to use the Services (“License”)
          in a manner captured in this Agreement, subject to the payment of all
          Fees to Tesseract (“Subscription”). The License granted to the
          Customer herein is limited, non-exclusive, non-transferable, non
          sub-licensable, revocable and restricted to the territory of India
          (subject to applicable export control regulations; unless Customer is
          expressly granted an additional right to use the Service in any other
          territory in the Order).{" "}
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.1.2&nbsp;</li>
        <li>
          The License granted is limited to the right to install, run and use
          the Services (on Customer’s own devices, or on any devices in the
          immediate possession of Customer and create Applications (defined
          below) solely for the purpose of operating its own internal business
          activities and within the limits of the scope of use and License
          Quantity Limits as agreed between Tesseract and Customer.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.1.3&nbsp;</li>
        <li>
          Subject to the above purpose and limits set out in Clauses 1.1.1 and
          1.1.2 of Section B (Services Specific Terms), the License to the SDK
          and Development Tools granted to the Customer is further limited to
          allowing the Customer to develop applications and software compatible
          only with Tesseract and its affiliates’ platforms and devices solely
          using the SDK and Development Tools for its internal business purposes
          (“Application”). The License granted under the Subscription shall be
          limited in time to the specified term of Subscription and end with the
          expiry or termination thereof. For the sake of clarity, it is
          expressly stipulated that the use of SDK and Development Tools is not
          permitted for the creation of any applications intended for use on or
          compatible to any platform other than Tesseract’s or its affiliates’
          platform, unless otherwise expressly permitted in writing by
          Tesseract. It is specified that no other rights beyond those
          explicitly outlined herein are being granted to the Customer under
          this Clause. The rights and permissions granted are strictly limited
          to those expressly detailed and do not extend to any additional or
          implied rights.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.1.4&nbsp;</li>
        <li>
          Additionally, the Customer acknowledges and agrees that Tesseract
          assumes no liability and hereby disclaims any responsibility
          concerning any Application developed by the Customer under this
          Clause. Consequently, any use or consequences arising from such
          Applications are solely the responsibility of the Customer, and
          Tesseract shall bear no liability in connection with the same.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.2&nbsp;</li>
        <li>
          <strong>Authorised Users</strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Subject to Clause 1 (License) of Section B (Services Specific
              Terms), the License provided hereunder to the Customer shall be
              solely handled by the Authorised Users of the Customer, on behalf
              of the Customer. “Authorised User” means: (i) any current
              employees, consultants or contractors authorized by Customer to
              use the Services solely for the support of Customer’s internal
              business, provided that such access and use shall be limited to
              their provision of services to Customer within the scope of their
              employment or assignment with the Customer; or (iii) in any other
              cases subject to prior written consent by Tesseract.
              <br></br>
              <br></br>
              Customer is responsible for the acts and omissions of its
              Authorised Users (including any other person who would access and
              use the Services by using the access credentials provided by
              Customer), as its own acts and omissions. In case of breach of any
              of the terms of this Agreement by Customer or any of its
              Authorized Users, Customer shall immediately upon notice from
              Tesseract or its affiliates cease and desist any use of the
              Services, remove all copies of the Services from Customer's
              devices and certify in writing to Tesseract within 7 (seven)
              business days of the date of such notice that it has done so. All
              obligations of Customer under this Agreement shall apply fully to
              any such Authorised Users as if they were Customers hereunder.
              <br></br>
              <br></br>
              Unless specifically agreed to the contrary, an Authorised User
              shall access and use the Services by using a personalized login
              (named user license) provided by Tesseract. Group or shared logins
              are prohibited. Any re-assignment of such personal login
              credentials is subject to specific written consent by Tesseract.
              The Customer is responsible for ensuring that its Authorized User
              maintain the security and confidentiality of their respective
              login credentials. In cases where reassignment of personal login
              credentials becomes necessary due to personnel changes or other
              legitimate reasons, the Customer shall request specific written
              consent from Tesseract. Tesseract, at its sole discretion, may
              grant or deny consent for the reassignment of personal login
              credentials. Any reassignment without the required written consent
              shall be considered a breach of this Agreement.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.3&nbsp;</li>
        <li>
          <strong>License Quantity Limits </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              The usable licensed units included in the scope of License
              acquired by the Customer, in particular regarding the amounts of
              licensed users or agents, managed devices, experts and annually
              allowed reassignments, storage limits, experience size limits,
              time limits, view limits etc., (“License Quantity Limits”) shall
              be agreed in writing by Tesseract and the Customer. If Customer
              exceeds the Licensed Quantity Limits during the Subscription
              Period (defined below), additional license fees will be charged
              for the excess usage (“Extra License Fees”) at the then current
              list price of Tesseract calculated with respect to the extra
              usage. Customer reserves the right to increase the License
              Quantity Limits or the Authorised Users, subject to additional
              payment to Tesseract at the then current list price of Tesseract
              as may be decided by Tesseract. However, the Customer cannot
              decrease the License Quantity Limits or the Authorised Users
              anytime during the Subscription Period.{" "}
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">1.4&nbsp;</li>
        <li>
          <strong>Usage analysis, right to audit and self-declaration </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Tesseract may analyze Customer’s use of the Services for security
              reasons as well as for product improvement, license auditing
              and/or marketing purposes. To that end, Tesseract may use, at its
              sole discretion, and implement technical measures regarding the
              functionality of the Services to assess whether Customer’s usage
              pattern is in line with the indicated usage volume and thus with
              the chosen license type, and to detect whether the contractually
              agreed scope of use is being exceeded by Customer. Tesseract may
              require Customer, at any time, to provide a self- declaration
              regarding its actual scope of use and/or usage pattern in a form
              and manner provided by Tesseract. The Customer shall provide
              Tesseract all necessary approvals and consents for provision of
              the necessary data/information under this Clause.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">2&nbsp;</li>
        <li>
          <strong>Services</strong>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">2.1&nbsp;</li>
        <li>
          <strong> Service Specification</strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              The functions and features of the Services available with respect
              to the Software may be separately provided by Tesseract to the
              Customer from time to time (“Service Specification”).{" "}
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">2.2&nbsp;</li>
        <li>
          <strong>System Requirements </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Customer is responsible for providing the appropriate system
              environment required for the use of respective Services in
              accordance with the system, connectivity, network, and any other
              software requirements provided by Tesseract from time to time
              (“System Requirements”). Customer shall be solely responsible for
              the download, installation, and configuration of the Services.
              Customized adjustment, development, integration with Customer´s
              system or external software, training of Customer´s Authorized
              Users, as well as any additional consulting or support services,
              are not included in the scope of Services and shall be subject to
              express written agreement between the parties. Tesseract may
              require Customer (and its Authorised Users) to sign up and/or
              create an account for the use of Services. It is clarified that
              the Services can only be accessed and used through the account
              created on Tesseract’s platforms. Tesseract may, at its sole
              discretion, further set certain account creation and verification
              requirements and/or criteria that Customer will be required to
              meet to use the Services under this Agreement.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">2.3&nbsp;</li>
        <li>
          <strong> Server Services </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              For the establishment of encrypted remote communication
              connections between different users of the Software, the Software
              must communicate with servers of Tesseract ( “handshake”). In
              addition, it may be necessary for the transmission of data in the
              context of a session (e.g. online meeting or remote maintenance)
              that encrypted data packets be forwarded by servers of Tesseract
              (so-called “routing”). Such handshake and routing are made
              available in connection with Tesseract’s Server Services.
              <br></br>
              <br></br>
              Tesseract provides Customer with the Server Services subject to
              the conditions set out in this Agreement. Customer acknowledges
              that the Server Services may be unavailable or include latency
              from time to time due to causes beyond the reasonable control of
              Tesseract and accordingly disclaims all liability in this regard.
              Additionally, Customer acknowledges that the end-to-end connection
              between different users of the Software is dependent on Customer’s
              internet connection to the data centre as well as Customer’s use
              of hardware and software (e.g. mobile devices, operating system)
              in compliance with System Requirements for the Software, all of
              which shall not be included in any of the services provided by
              Tesseract and shall be Customer’s responsibility at its own costs.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">2.4&nbsp;</li>
        <li>
          <strong> Programming interfaces </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              At Tesseract’s discretion, it may provide for the use of
              programming interfaces or other software interfaces (“API”) which
              may enable applications of Customer (collectively “Third-party
              Software”) to communicate with the Software or the servers
              provided by Tesseract as part of the Server Services. Tesseract,
              in its sole discretion, may change or switch off APIs at any time
              without any obligation or liability to Customer. The respective
              provider of such Third-party Software shall be solely responsible
              for the Third-party Software. The provisions of the Agreement
              shall have precedence over the terms of any such Third-party
              Software and Tesseract is under no obligation to test, validate or
              otherwise review Third-party Software, and shall have no liability
              for any Third-party Software or in connection with the use
              thereof.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">2.5&nbsp;</li>
        <li>
          <strong>Changes to the Services </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Some features and functions of the Service(s) provided by
              Tesseract may include or depend on certain third-party components
              which may be subject to changes by such third parties. Tesseract
              is entitled to modify or limit such features and functions, for
              the proper functioning of the Services. The Customer acknowledges
              and agrees that the third party components are owned by third
              parties and that Tesseract is absolved of any liability in this
              regard.
              <br></br>
              Tesseract reserves the right to change the Services in the context
              of updates and/or Release Versions as well as other Services
              (including the System Requirements) for good cause. Such good
              cause exists especially if the change is required due to (i) a
              necessary adaptation required by applicable law, regulation, court
              order, or order of authority; (ii) changes to applicable technical
              framework conditions (e.g., new encryption standards); (iii) the
              protection of system security; or (iv) in connection with the
              provision of the Services
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">2.6&nbsp;</li>
        <li>
          <strong> Release Versions </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Tesseract may, at its sole discretion, but shall not be obligated
              to, provide releases of the Software for download (“Release
              Versions”). Additional features to the Software which are
              separately marketed and/or priced by Tesseract (“Additional
              Features”) shall not qualify as Release Versions. All rights of
              use set forth in the Agreement applicable to the Software shall
              also apply to Release Versions. Tesseract reserves the right to
              determine the timing, frequency, and content of these Release
              Versions, aiming to enhance the Customer's experience with the
              Software.
              <br></br>
              <br></br>
              Customer is obligated to update the Software with any Release
              Version at its own cost as soon as reasonably practicable.
              Customer’s systems shall comply with the System Requirements to
              accommodate new Release Versions. Any malfunctioning of the
              Software or failure in the Services that is attributable to
              non-compliance with this Clause shall be Customer’s sole
              responsibility.
              <br></br>
              <br></br>
              The Customer is obligated to maintain the License of the Software
              granted originally under this Agreement. Minor release versions
              (e.g., version XX.1, XX.2) shall be made available only when the
              License granted to the Customer under this Agreement is valid as
              per the terms of this Agreement (“Minor Release Version”). Minor
              Release Versions may contain the correction of errors, security
              patches as well as minor improvements of functions (e.g.,
              optimizations in the program execution speed) and will be marked
              by Tesseract – in its sole discretion – by a change in the number
              behind the main version number.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li role="presentation">2.7&nbsp;</li>
        <li>
          <strong> Services and Subscription Support </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>2.7.1&nbsp;</li>
            <li>
              Tesseract may, but will have no obligation to, perform certain
              functions associated with the purchase, activation, support and
              management of Customer purchased Services. The Customer shall
              co-operate with Tesseract, for the performance of such functions,
              as required by Tesseract from time to time. The Services are
              provided on an “as-is” and “as available” basis, and Tesseract
              does not guarantee that the Services will be free from any
              material faults, interruption or unavailability. Tesseract will
              reasonably endeavor to assist the Customer with general queries
              pertaining to operational or technical support issues or questions
              related to the Services.{" "}
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>2.7.2&nbsp;</li>
            <li>
              Tesseract may and retains the authority to provide the Customer
              with administrative access credentials to a Customer for Services
              ordered by such Customer. In the event Tesseract requires access
              to such administrative access credentials provided to a Customer,
              for the provision of technical support in respect of the Services
              ordered by a Customer, the Customer agrees to provide these
              credentials for the sole purpose of facilitating effective
              technical support and acknowledges their responsibility to keep
              these credentials secure and confidential at all times, ensuring
              that they are not misused or disclosed to unauthorized individuals
              or third parties. Tesseract will abide by applicable law with
              respect to the use and handling of such administrative access
              credentials.{" "}
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>3.&nbsp;</li>
        <li>
          <strong>Customer Content </strong>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>3.1&nbsp;</li>
        <li>
          Subject to the terms of Subscription, Tesseract may make available to
          Customer, certain functions for the Customer to upload, store or
          integrate content using the Services including but not limited to
          texts, graphics, audio or video files or other digital data and
          content (“Customer Content”). Other than as indicated herein, Customer
          shall retain all rights to and be wholly responsible for the Customer
          Content. Customer ensures that it holds all necessary rights to the
          Customer Content (e.g., intellectual property rights including images,
          trademarks and copyrights) for processing within the scope of the
          Agreement and subsequently assumes the sole liability and defence
          against all claims of third parties, asserting claims against
          Tesseract due to the alleged violation of rights in connection with
          Customer Content.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>3.2&nbsp;</li>
        <li>
          In order to display Customer Content on the Services, and to allow
          other users to view them (where applicable), you grant us all
          applicable rights in Customer Content including but not limited to the
          following:
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>(a)&nbsp;</li>
            <li>
              For all of Customer Content, you hereby grant Tesseract a license
              to translate, modify (for technical purposes, for example making
              sure your content is viewable on a mobile phone as well as a
              computer) and reproduce and otherwise act with respect to Customer
              Content, in each case to enable us to operate the Services.{" "}
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>(b)&nbsp;</li>
            <li>
              You may store Customer Content in your own account created on
              Tesseract’s platform, in a manner that is not accessible by any
              other user except you (“Private Content”). If you create or store
              such Private Content on the Services, then you grant Tesseract the
              license above, as well as a license to display, perform, and
              distribute your Private Content for the sole purpose of making
              that Private Content accessible to you and providing the Services
              necessary to do so.{" "}
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>(c)&nbsp;</li>
            <li>
              You may share Customer Content only through the Services in a
              manner that only certain specified users can view (for example, a
              Private Content upload to one or more other users) (“Limited
              Audience Content”). If you create, store, or share such Limited
              Audience Content on the Services, then you grant Tesseract the
              licenses above, as well as a license to display, perform, and
              distribute your Limited Audience Content for the sole purpose of
              making that Limited Audience Content accessible to such other
              specified users, and providing the Services necessary to do so.
              Also, you grant such specified users a license to access that
              Limited Audience Content. If you are uploading Customer Content
              you did not create or own, you are responsible for ensuring that
              the Customer Content you upload has all adequate intellectual
              property rights and permissions and is licensed under terms that
              grant the aforementioned permissions to such other specified users
              with whom the Customer chooses to share such content. Tesseract
              shall not be held liable for any issues or disputes arising from
              the sharing of Customer Content through the Services, including
              Limited Audience Content. In no event shall Tesseract be held
              responsible or liable for any claims, damages, or disputes related
              to the Customer's choice of sharing content with specified users.{" "}
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>(d)&nbsp;</li>
            <li>
              If you share Customer Content publicly on the Services and/or in a
              manner that more than just you or certain specified users can view
              (“Public Content”), then you grant Tesseract the licenses above,
              as well as a license to use, reproduce, prepare derivative works
              of, display, perform, and distribute your Public Content for the
              purpose of making that Public Content accessible to all users of
              Services and providing the Services necessary to do so, as well as
              all other rights necessary to use and exercise all rights in that
              Public Content in connection with Tesseract’s business, including
              without limitation for promoting and redistributing part or all of
              the Services (and derivative works thereof) in any media formats
              and through any media channels. However, Tesseract will reasonably
              endeavor to notify you if it uses your Public Content for its own
              advertising and promotional purposes and you agree that you will
              not be entitled to any payments in connection with such
              advertising. Also, you grant all other users of the Services a
              license to access that Public Content, and to use and exercise all
              rights in it, as permitted by the functionality of the Services.
              If you are uploading Customer Content you did not create or own,
              you are responsible for ensuring that the Customer Content you
              upload has adequate permissions and is licensed under terms that
              grant these permissions to all other users of the Services with
              whom the Customer chooses to share such content. It is hereby
              clarified that Public Content, in addition to the Customer
              Content, may also include any content that you create, use or
              otherwise provide through Software. Tesseract shall not be held
              liable for any issues or disputes arising from the sharing of such
              Public Content through the Service. In no event shall Tesseract be
              held responsible or liable for any claims, damages, or disputes
              related to the Customer's choice of sharing content under this
              Clause.{" "}
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>3.3&nbsp;</li>
        <li>
          You agree that the licenses you grant are royalty-free, perpetual,
          sub-licensable and transferable, irrevocable, and worldwide. You agree
          that Tesseract may display advertising embedded in, in proximity to,
          or otherwise in connection with displaying Customer Content on the
          Services, and you will not be entitled to any payments in connection
          with such advertising. Finally, you understand and agree that
          Tesseract, in performing the required technical steps to provide the
          Services to our users (including you), may need to make changes to
          Customer Content to conform and adapt Customer Content to the
          technical requirements of connection networks, devices, services, or
          media and applicable law. It is further clarified that the foregoing
          licenses include the rights to make such changes under this Clause.{" "}
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>3.4&nbsp;</li>
        <li>
          Customer shall ensure that the Customer Content does not contain
          Prohibited Customer Content (defined below). Customer shall not use
          the Services to host, display, upload, modify, publish, transmit,
          update or share any information or content which:{" "}
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>(a)&nbsp;</li>
            <li>
              belongs to another person and to which the Customer does not have
              any right;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>(b)&nbsp;</li>
            <li>
              is grossly harmful, harassing, blasphemous, defamatory, obscene,
              pornographic, pedophilic, libelous, invasive of another’s privacy,
              hateful, or racially, ethnically objectionable, disparaging,
              relating or encouraging money laundering or gambling or otherwise
              unlawful in any manner whatsoever; or unlawfully threatening or
              unlawfully harassing including but not limited to “indecent
              representation of women” within the meaning of the Indecent
              Representation of Women (Prohibition) Act, 1986;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>(c)&nbsp;</li>
            <li>is misleading in any way; </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>(d)&nbsp;</li>
            <li>
              is patently offensive to the online community, such as sexually
              explicit content, or content that promotes obscenity, paedophilia,
              racism, bigotry, hatred or physical harm of any kind against any
              group or individual;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>(e)&nbsp;</li>
            <li>harasses or advocates harassment of another person;</li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>(f)&nbsp;</li>
            <li>
              involves the transmission of “junk mail”, “chained letters”, or
              unsolicited mass mailing or “spamming”;{" "}
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>(g)&nbsp;</li>
            <li>
              promotes illegal activities or conduct that is abusive,
              threatening, obscene, defamatory or libelous;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>(h)&nbsp;</li>
            <li>
              infringes upon or violates any third party’s rights (including,
              but not limited to, intellectual property rights, rights of
              privacy or rights of publicity);{" "}
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>(i)&nbsp;</li>
            <li>
              promotes an illegal or unauthorized copy of another person’s
              intellectual property;{" "}
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>(j)&nbsp;</li>
            <li>
              provides instructional information about illegal activities such
              as making and/ or buying illegal weapons, violating someone’s
              privacy, or providing or creating computer viruses;{" "}
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>(k)&nbsp;</li>
            <li>
              solicits gambling or engages in any gambling activity which we in
              our sole discretion believe is or could be construed to be as
              illegal;
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>(l)&nbsp;</li>
            <li>harms minors in any way; </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>(m)&nbsp;</li>
            <li>violates any applicable law for the time being in force; </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>(n)&nbsp;</li>
            <li>impersonates another person; </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>(o)&nbsp;</li>
            <li>
              contains software viruses or any other computer code, files or
              programs designed to interrupt, destroy or limit the functionality
              of any computer resource; or contains any trojan horses, worms,
              time bombs, cancelbots, easter eggs or other computer programming
              routines that may damage, detrimentally interfere with, diminish
              value of, surreptitiously intercept or expropriate any system,
              data or personal information; and{" "}
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>(p)&nbsp;</li>
            <li>
              threatens the unity, integrity, defence, security or sovereignty
              of India, friendly relations with foreign states, or public order
              or causes incitement to the commission of any cognizable offense
              or prevents investigation of any offense or is insulting any other
              nation (collectively referred to as “Prohibited Customer
              Content”).
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>3.5&nbsp;</li>
        <li>
          Tesseract is not obliged to check, verify or pre-approve whether the
          Customer Content contains Prohibited Customer Content. However,
          Tesseract reserves the right to take appropriate measures including
          the right to refuse or suspend the provision of the Services in whole
          or in part if and to the extent that Prohibited Customer Content is
          uploaded using your personal login credentials associated with the
          Customer's License or account.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>4&nbsp;</li>
        <li>
          <strong>Customer Hosting</strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Following conditions only apply to the special use case of
              Customer Hosting as defined below: <br></br>
              <br></br>
              Depending on the Software feature and subject to the agreement
              between the parties for the specific use case, Tesseract may, at
              its sole discretion, and in addition to the Software being made
              available by Tesseract for installation on Customer’s end devices,
              allow for certain parts of the Product server-side software to be
              installed and hosted on Customer’s or third-party server
              infrastructure (“Customer Hosting”), thereby replacing the
              respective Server Services otherwise provided by Tesseract.
              Tesseract provides no warranties or representations and shall
              subsequently not be liable for the Customer Hosting.
              <br></br>
              <br></br>
              Customer shall ensure that the server infrastructure running the
              server-side software and all third-party software components
              required for the performance of Customer Hosting, including
              operating systems, hardware drivers and auxiliary software is
              always updated to the latest version available by the respective
              manufacturer or publisher. Tesseract shall not be liable for
              damages resulting from Customer´s non-compliance with the update
              obligations hereunder.
              <br></br>
              <br></br>
              Where Tesseract reasonably believes that the security or integrity
              of the Customer Hosting has been compromised, Tesseract shall at
              its own discretion have the right to block any connection between
              the Customer Hosting and the Tesseract Server Services until the
              underlying issue has been resolved and the same has been verified
              by Tesseract. Tesseract shall in such cases make reasonable
              efforts to notify Customer and provide relevant information in
              that respect.
              <br></br>
              <br></br>
              In the case of Customer Hosting, Tesseract shall have the right to
              audit Customer’s compliance with the terms of this Agreement and
              the applicable laws: (i) every six (6) months, by way of
              establishing a secure remote connection to the Software installed
              on Customer’s systems, for purposes of evaluation of the usage
              recorded on Software on Customer’s systems. Customer shall make
              available additional information reasonably necessary to
              demonstrate compliance with the usage restrictions, including all
              limitations set out under the Agreement; and (ii) once a year, by
              conducting an audit at the Customer’s premises, on which the
              Software is deployed, for which Tesseract shall notify Customer no
              less than seven (7) business days prior to such audit and conduct
              such audit during normal business hours. At Tesseract’s sole
              discretion, Tesseract shall have the right to have the audit
              performed by a duly authorized third party bound by obligations of
              confidentiality.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>5&nbsp;</li>
        <li>
          <strong>Limitation of Warranty</strong>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>5.1&nbsp;</li>
        <li>
          <strong>Limited warranty for subscription</strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Tesseract shall, subject to this Section B (Services Specific
              Terms), maintain Services using commercially reasonable care and
              skills during the term of Subscription.{" "}
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>5.2&nbsp;</li>
        <li>
          <strong>Maintenance </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              The maintenance by Tesseract set out herein does not include (i)
              any adaptation of the Services to new operating systems or new
              operating system versions. In the event the Customer decides to
              transition to a new operating system or upgrade to a new version
              thereof, any necessary adjustments or adaptations to the Services
              shall be the responsibility of the Customer. Tesseract will not be
              liable for the development or implementation of these adaptations,
              (ii) adaptation of the Services to the scope of functions of
              competing products, (iii) establishment of compatibility with new
              data formats or Release Versions. It is clarified that maintenance
              for Release Versions will be provided in a manner consistent with
              the terms of maintenance for the Software, or (iv) provision of
              any functionality which is no longer supported by Tesseract.
              Should the Customer seek specific modifications or custom features
              that are not part of the standard service offering, these will be
              considered separate projects and may be subject to additional fees
              and timelines.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>5.3&nbsp;</li>
        <li>
          <strong>Incidents or service requests </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Customer may report incidents or service requests related to the
              Software licensed to the Customer in accordance with the support
              and service level agreement to be separately agreed by the
              Parties.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>5.4&nbsp;</li>
        <li>
          <strong>Infringement of third party right </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              If a Service infringes a third party’s patent or copyright,
              Tesseract will, at its sole discretion, if required under
              applicable law: (i) obtain for Customer the right to continue
              using the Service; or (ii) replace or modify the Service so that
              it no longer infringes the relevant intellectual property right.
              If neither of the remedies in (i) or (ii) are reasonably
              available, either party shall have the right to terminate the
              Agreement with immediate effect, and this termination shall be
              executed with no liability imposed upon Tesseract. It is clarified
              that nothing under this Clause shall relieve the Customer of its
              payment obligations under this Agreement.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>5.5&nbsp;</li>
        <li>
          <strong>Claims for damages </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Any potential claims for damages based on a breach of warranty or
              defective performance shall be subject to the limitation of
              liability stipulated in the Master Terms.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>5.6&nbsp;</li>
        <li>
          <strong>Limitation period </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              The Customer shall be required to report all issues in strict
              accordance with the service level agreements. It is further stated
              that Customer’s remedies and claims for any defect shall expire
              after twelve (12) months from the date the defect has been
              discovered by Customer (which date shall be determined upon the
              receipt of an incident ticket regarding any defect and/or issue)
              or, in the event of ignorance by the Customer, twelve (12) months
              after Customer should reasonably have been aware of such defect.
              This shall not apply to a guarantee period expressly granted by
              Tesseract.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>6&nbsp;</li>
        <li>
          <strong>Other applicable terms and conditions </strong>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>6.1 &nbsp;</li>
        <li>
          Customer shall at all times accept and comply with the terms and
          conditions/terms of use for Services available at
          https://legal.jiorealityos.com/tesseract-enterprise/terms-and-conditions
          (applicable to Tesseract Enterprise Suite) and
          https://legal.jiorealityos.com/horizons/terms-of-service (applicable to
          Tesseract Horizons Portal).
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>6.2 &nbsp;</li>
        <li>
          In regard to the use of any other third-party software and services,
          Customer acknowledges that their applicable terms and conditions
          govern Customer’s use of such software and services, and it is the
          Customer’s sole responsibility to read, understand and adhere to such
          terms and conditions. Tesseract will not assume any liability for
          performance-related issues, losses, damages, or consequences in
          relation to the Services arising from the utilization of such
          third-party software and services. Any warranties or support offered
          for these third-party software and services, if any, are solely the
          responsibility of the respective third-party service provider.
          Tesseract explicitly disclaims and further states that it bears no
          responsibility for any consequences or liabilities resulting from the
          use of such third-party services and software.
        </li>
      </ul>

      <ul className="tnc-jioimmerse-wrapper-ul_style">
        <li role="presentation">
          <strong>
            C. <u>Hardware Specific Terms </u>
          </strong>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>
          The Hardware Specific Terms contain the terms and conditions that
          additionally apply to your access to virtual reality, augmented
          reality and mixed reality glasses, its accessories or similar items
          provided by Tesseract and/ or its affiliates (<strong>“Hardware”</strong>) to the
          extent, Tesseract is facilitating its access either through purchase
          or through lease of Hardware under this Agreement and all obligations
          and terms including any liability or lease of the Hardware shall be as
          per the documentation entered into between Tesseract’s affiliates and
          the Customer.
          <br></br>
          <br></br>
          <strong>Applicability</strong> - This Section C (Hardware Specific
          Terms) shall be applicable in cases where Hardware is purchased or
          leased by the Customer.
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>1. &nbsp;</li>
        <li>
          <strong>Facilitation of Hardware Purchase</strong>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>1.1 &nbsp;</li>
        <li>
          <strong>Applicability </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              This Part will apply to sale of Hardware to and purchase by the
              Customer from Tesseract (which sale and/or purchase may be
              facilitated by Tesseract, as the case may be) and/ or its
              affiliates (“<strong>Hardware Purchase</strong>”). <br></br>
              <br></br>
              Any additional services related to the Hardware Purchase,
              including but not limited to the setup, installation, or
              trainings, shall not be provided under these Hardware Specific
              Terms. Such services may be agreed between the Customer and the
              entity providing access to such Hardware upon written request but
              shall remain subject to a separate agreement and remuneration.
              <br></br>
              <br></br>
              It is further stated that:
              <ul className="tnc-jioimmerse-wrapper-content">
                <li>(a)&nbsp;</li>
                <li>
                  Tesseract explicitly disclaims any responsibility for the
                  manufacturing of Hardware provided under this Agreement.
                  Tesseract's role is solely that of a facilitator in the
                  procurement and distribution of Hardware, which is
                  manufactured by third-party manufacturers. Customers
                  acknowledge and agree that Tesseract is not engaged in the
                  manufacturing process of the Hardware, and any claims,
                  concerns, or disputes related to the manufacturing, quality,
                  defects, or recall of the Hardware should be directed to the
                  respective manufacturer. Tesseract disclaims any warranties
                  and guarantees regarding the Hardware and, to the extent
                  permitted by applicable law, shall not be held responsible for
                  any defects, malfunctions, recalls or issues related to the
                  Hardware.
                </li>
              </ul>
              <ul className="tnc-jioimmerse-wrapper-content">
                <li>(a)&nbsp;</li>
                <li>
                  Furthermore, Customers understand that the usage of the
                  Hardware is subject to the manufacturer's specifications,
                  guidelines, and warranties, which Tesseract does not control
                  or warrant. Tesseract shall not be liable for any damages,
                  losses, or issues arising from the Customer's failure to use
                  the Hardware in accordance with the manufacturer's
                  instructions.
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>1.2&nbsp;</li>
        <li>
          <strong>Obligations of Customer </strong>{" "}
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Customer shall pay to Tesseract and/ or its affiliates (as
              provided in the invoice for Hardware) the purchase price and
              delivery fees as specified in the Order. <br></br>
              <br></br>
              Customer shall be responsible for the setup and configuration of
              the Hardware following the delivery thereof which terms shall be
              provided by the Tesseract and/ or its affiliates.
              <br></br>
              <br></br>
              In addition to this Section C (Hardware Specific Terms),
              additional terms, and conditions applicable to Customer’s use of
              the Hardware shall be separately communicated in writing to the
              Customer by Tesseract and/or its affiliate, which shall also be
              binding on the Customer (“Hardware Terms”). In regard to the use
              of the Hardware, you acknowledge that the Hardware Terms govern
              your use of the Hardware, and it is your sole responsibility to
              read, understand and adhere to such Hardware Terms. Tesseract will
              not assume any liability including for performance-related issues,
              damages, or consequences arising from the utilization of such
              Hardware. Tesseract explicitly disclaims and bears no
              responsibility for any consequences or liabilities resulting from
              the use of such Hardware. It is explicitly clarified that in the
              event of any conflict or inconsistency between the Hardware Terms
              and this Agreement with respect to the use of the Hardware, the
              Hardware Terms shall take precedence and prevail over any
              conflicting provisions to the extent necessary to eliminate such
              conflict or inconsistency unless explicitly agreed otherwise
              between the parties in writing.
              <br></br>
              <br></br>
              The Customer acknowledges and agrees that its compliance with the
              Hardware Terms is integral to Tesseract's provision of Services.
              The Customer is obliged to adhere to the Hardware Terms and use
              the Hardware accordingly. It is further acknowledged by the
              Customer that the use of the Hardware should not, in any way,
              detrimentally impact the provision of Services. The Customer also
              accepts that Tesseract reserves the right to hold the Customer
              liable for any breach of these Hardware Terms.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>1.3&nbsp;</li>
        <li>
          <strong>Hardware requirements </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              The use of the Hardware by the Customer will be subject to
              specifications as provided either by Tesseract and/or its
              affiliates or by the entity providing such Hardware including but
              not limited the manufacturer of such Hardware.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>1.4&nbsp;</li>
        <li>
          <strong>Limitation of warranty/ warranties </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              The terms in relation to warranty and limitation of warranty in
              relation to the Hardware shall be governed by separate ‘Warranty
              Terms and Conditions’ provided by Tesseract and/ or its affiliates
              in relation to the relevant Hardware.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>2&nbsp;</li>
        <li>
          <strong>Hardware Lease </strong>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>2.1&nbsp;</li>
        <li>
          <strong>Applicability </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              This Part, the hardware lease terms, will apply to the temporary
              transfer of Hardware (which process may be facilitated by
              Tesseract) for use, for a limited time period as may be determined
              by Tesseract during the duration of the Agreement (“
              <strong>Leased Hardware</strong>”), to the Customer by Tesseract
              and/ or its affiliates (“<strong>Hardware Lease</strong>”).
              <br></br>
              <br></br>
              The subject matter of the Hardware Lease shall be the supply of
              the Hardware as provided in the applicable Order and the temporary
              transfer of usage rights and possession of the Hardware and the
              payment of the agreed fee. Furthermore, the parties acknowledge
              that the Hardware Lease does not constitute a sale of the
              Hardware, but rather a temporary arrangement for its use, and
              ownership shall remain with the entity owning such Hardware.
              <br></br>
              <br></br>
              Unless otherwise specified in this Section, the Hardware Specific
              Terms shall apply to the Hardware Lease mutatis mutandis.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>2.2&nbsp;</li>
        <li>
          <strong>Transfer of possession </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Tesseract and/ or its affiliates shall grant to Customer the
              limited usage rights to and possession of the Hardware for the
              term of the Hardware Lease.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>2.3&nbsp;</li>
        <li>
          <strong>Obligations of Customer </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>2.3.1&nbsp;</li>
            <li>
              Tesseract and/ or its affiliates shall grant to Customer the
              limited usage rights to and possession of the Hardware for the
              term of the Hardware Lease.
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>2.3.2&nbsp;</li>
            <li>
              Customer shall bear all operating costs incurred when using the
              Leased Hardware, including all cleaning and running costs. All
              maintenance and repair costs as well as any necessary repairs of
              the equipment, components and accessories of the Leased Hardware
              which are based on the use by the Customer shall be carried out by
              the Customer at Customer’s own expense.
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>2.3.3&nbsp;</li>
            <li>
              Customer shall notify Tesseract immediately of any damage to or
              theft of the Leased Hardware, providing where available,
              comprehensive information on the cause of and the person
              responsible for the damage. In case of any damage to the Leased
              Hardware, which do not regularly occur solely as a result of
              normal contractual wear and tear, Customer shall solely bear the
              burden of proof that the deterioration of the Leased Hardware was
              not caused by it and was not its fault. In case of damages to the
              Leased Hardware, that are not attributable to ordinary wear and
              tear, Customer shall bear the burden of proof that the
              deterioration of the Leased Hardware was not caused by it and was
              not its fault.
            </li>
          </ul>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>2.3.4&nbsp;</li>
            <li>
              Customer shall require the prior written consent by Tesseract and/
              or its affiliates in case of Customer wishing for third parties to
              use the Leased Hardware, including but not limited to subleasing
              or other complete or partial transfer of possession of the Leased
              Hardware (together the “Transfer of Use”). In the event of any
              Transfer of Use to third parties, Customer shall be liable for all
              damage caused by the third party to whom the use of the Leased
              Hardware was transferred. Moreover, Customer shall assume
              liability for any damage or loss incurred by the third party
              during their use of the Leased Hardware. It is essential that
              Customer ensures that any third party using the Leased Hardware is
              fully aware of and adheres to the terms and conditions of this
              Agreement to prevent any unauthorized use or damage.{" "}
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>2.4&nbsp;</li>
        <li>
          Term and termination
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Unless otherwise specified in the Order, the initial term of the
              Hardware Lease shall be three (3) months (“
              <strong>Initial Term</strong>”) and be automatically renewed for
              subsequent periods of three (3) months (each a “
              <strong>Renewal Term</strong>”), unless either party notifies the
              other party no less than thirty (30) days prior to the end of the
              Initial Term or any Renewal Term that the Agreement shall not
              renew. <br></br>
              <br></br>
              Termination notice, including the notification of non-renewal of
              Agreement pursuant to Clause 1.11 (Term and termination) of
              Section A (Master Terms), must be made in writing form (by signed
              letter or email). Customer shall address its termination notice to
              Tesseract Imaging Limited (TC-22, Reliance Corporate Park,
              Ghansoli, Navi Mumbai 400 701) or by email to
              {enterpriseSupportEmail}.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>2.5&nbsp;</li>
        <li>
          Consequence of termination
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Customer shall at its own costs return the Leased Hardware at the
              end of the Hardware Lease including all accessories, manuals or
              documents. It is agreed and acknowledged by the Customer that the
              Leased Hardware shall be returned to Tesseract or to its
              affiliates (as the case may be) within three (3) days of
              termination or expiry of the Agreement. For the purposes of this
              Clause, any delay on part of the Customer to return the Leased
              Hardware to Tesseract within the stipulated time period shall
              constitute and shall be regarded as theft, and consequently a
              breach of the Agreement. The Customer agrees and acknowledges that
              it shall fully indemnify Tesseract and/ or its affiliates against
              any such theft of Leased Hardware. Tesseract further reserves the
              right to inspect and verify the condition of the Leased Hardware
              during the Hardware Lease term and upon return. Any costs related
              to refurbishment or repairs resulting from damage shall be charged
              to the Customer.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-ul_style">
        <li role="presentation">
          <strong>
            D. <u>Additional Services Specific Terms </u>
          </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              The Additional Services Specific Terms contain the terms and
              conditions that apply to the provision of additional services by
              Tesseract to support the use of Services and Hardware, e.g.
              installation, configuration, customizations and integration of
              Services in Customer´s environment or third-party interface, as
              well as related IT services, content development, production
              services, scanning services, consulting, support and training
              (collectively “Additional Services”).
              <br></br>
              <br></br>“Customer” in this Section D (Additional Services
              Specific Terms) refers to the party who only orders the Additional
              Services from Tesseract, which might not be the same entity
              (Customer in the context of Section B (Services Specific Terms) of
              the Agreement) who acquires the License for Tesseract’s Services.
              <br></br>
              <br></br>
              <strong>Applicability</strong> - This Section D (Additional
              Services Specific Terms) shall be applicable in cases where
              Additional Services are subscribed, purchased or otherwise used by
              the Customer.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>1.&nbsp;</li>
        <li>
          <strong>Subject Matter</strong>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>1.1&nbsp;</li>
        <li>
          <strong>Contractual basis </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              The Additional Services are not included in the Subscription for
              License and therefore the parties explicitly need to request for
              and agree on the provision of such services.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>1.2&nbsp;</li>
        <li>
          <strong>Contract for service </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Unless otherwise explicitly stipulated in the Agreement, the
              respective order on provision of Additional Services shall be
              deemed as a contract for service, and the Additional Services
              shall be provided pursuant to Clause 5 (Additional Services Fees;
              reimbursement of expenses) of Section D (Additional Services
              Specific Terms). The listed items of Additional Services in the
              order serve only as a description of the service content and scope
              and shall not be interpreted as commitment of Tesseract to
              guarantee or warrant specific outcomes, achievements, or
              suitability of deliverables for the intended use or business
              purposes of Customer.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>1.3&nbsp;</li>
        <li>
          <strong>Service description </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              In the event of a conflict or inconsistency, Tesseract will
              perform the Additional Services as described in the Order in the
              following descending order: - A transaction document (e. g. Scope
              of Work) specifying the service items and performance details in
              writing signed by both parties; - Any further requests, plans,
              policies or terms of Customer that might be accepted by Tesseract
              in connection with the Order, which shall be confirmed in writing
              (with signature) to be effective; - Service description in
              business proposal provided by Tesseract and accepted by Customer.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>1.4&nbsp;</li>
        <li>
          <strong>
            Retention of intellectual property rights; no transfer of title{" "}
          </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Except as otherwise expressly agreed to in writing by both parties
              by designating such deliverables as a “work for hire”, the
              transfer of title or granting of right to use (licensing) is not a
              subject matter included in the service scope of Additional
              Services, and nothing in this Agreement or order for Additional
              Services will otherwise function to transfer any of either party's
              intellectual property rights to the other party, so each party
              will retain exclusive interest in and ownership of its own
              intellectual properties. The right of Customer to use any
              Materials or Work Results delivered by Tesseract shall be subject
              to Clause 6 (Intellectual Property Rights; use right) of Section D
              (Additional Services Specific Terms).
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>1.5&nbsp;</li>
        <li>
          <strong>Third-party service recipient</strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Tesseract may, insofar as per the terms agreed in the order,
              provide Additional Services on the device or network of a
              third-party appointed by Customer as service recipient
              (“Third-Party Service Recipient”). In this case, the Customer
              shall be liable for the acts and omission of the Third-Party
              Service Recipient in receiving the Additional Services as such of
              its own. The Third-Party Service Recipient is not a party to this
              Agreement or order, nor shall it be a third-party beneficiary of
              the Agreement or order. The Customer shall exercise due diligence
              in supervising the Third-Party Service Recipient's compliance with
              the terms of this Agreement and the Order, to ensure that the
              provision of Additional Services to the Third-Party Service
              Recipient adheres to the agreed-upon terms. Any deviating
              contractual conditions, warranties and commitments regarding
              Additional Services agreed upon between Customer and such
              Third-Party Service recipient shall not be binding upon Tesseract.
              Tesseract maintains that such agreements between the Customer and
              Third-Party Service Recipients are independent arrangements and
              will not affect the terms and obligations outlined in this
              Agreement or the associated order.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>2&nbsp;</li>
        <li>
          <strong>Performance of Additional Services</strong>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>2.1&nbsp;</li>
        <li>
          <strong>Place of performance </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              The Additional Services will be provided at the place of
              performance specified in the order. If no place of performance is
              stipulated, the Additional Services will be provided as remote
              service or from and/or at the premises of Tesseract.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>2.2&nbsp;</li>
        <li>
          <strong>Place of performance </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              The timelines of the Additional Services will be agreed mutually
              by the parties. Unless otherwise agreed by the parties in writing,
              time will not be of essence and the provision of Additional
              Services shall not constitute an absolute fixed-date transaction.{" "}
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>2.3&nbsp;</li>
        <li>
          <strong>Language </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Unless otherwise stipulated in writing by the parties, the
              language of the Additional Services will be English.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>3&nbsp;</li>
        <li>
          <strong>
            Requirements for the provision of services; Duties and obligations
            of Customer{" "}
          </strong>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>3.1&nbsp;</li>
        <li>
          <strong>Customer responsibilities </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              The provision of Additional Services requires the fulfilment of
              certain technical requirements placed on the hardware and software
              as well as network environment which lies in the responsibility of
              Customer. Customer shall provide cooperation and promote the
              Additional Services in every phase through active and appropriate
              participation and contribution. In particular, it shall provide
              Tesseract with the required access to and information, documents
              and data, IT infrastructure and other means necessary for the
              proper performance and proceeding of the Additional Services.
              Timely provision of accurate information, documentation, and data
              by the Customer is crucial for the effectiveness and efficiency of
              Additional Services. The Customer should ensure that any requested
              materials and resources are supplied without undue delay.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>3.2&nbsp;</li>
        <li>
          <strong>On-site Services </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              If the Additional Services shall be provided on-site and outside
              the business premises of Tesseract, Customer shall provide at its
              own costs the corresponding premises and all technical
              requirements which are necessary for the purpose, especially the
              auxiliary equipment required under applicable laws, the necessary
              hardware and software, transmission equipment, access, network
              connections and workspaces. Customer shall be obliged to take all
              necessary measures at the place of performance to protect the
              health and ensure the safety of Tesseract’s developers,
              sub-contractors and other auxiliary personnel.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>3.3&nbsp;</li>
        <li>
          <strong>Customer System </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Where the Additional Services shall be performed by accessing the
              network system of Customer or a third party appointed by Customer
              (collectively referred to as “Customer System”), Customer shall
              grant Tesseract, its auxiliary personnel and subcontractors prompt
              and unimpeded access to such system and its components.
              <br></br>
              <br></br>
              In case of technical problems with the hardware or software
              components of Customer System during the Additional Services,
              Customer will provide expert technical assistance at its own
              expense. During the Additional Services, Customer will guarantee
              the availability of at least one (1) employee who is familiar with
              Customer’s computer systems and processes and who, upon request,
              will be able to give expert advice and information. The Customer
              will ensure such employee’s immediate availability during the
              provision of Additional Services.
              <br></br>
              <br></br>
              Customer shall promptly notify Tesseract of any disruptions,
              shutdowns or disassembly of Customer System or any IT
              infrastructural changes which could make it harder or impossible
              for Tesseract to perform the Additional Services. The Customer
              shall provide all necessary assistance as may be required by
              Tesseract in this regard.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>3.4&nbsp;</li>
        <li>
          <strong>Data back-ups </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Customer shall be solely responsible for making proper data
              backups in the Customer System in accordance with applicable laws,
              the current state of technology and industrial common practice. If
              Customer has otherwise contractually tasked Tesseract with a data
              backup service, the content and scope of the data backup by
              Tesseract shall be defined exclusively by such separate contract.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>3.5&nbsp;</li>
        <li>
          <strong>Software version; installation </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Unless otherwise agreed to by the parties, the Additional Services
              in relation to the Software (e. g. installation, configuration,
              application, integration, update), will be provided for the most
              current version of the Software. Customer shall ensure the
              fulfilment and maintenance of the System Requirements as set out
              in this Agreement for the respective Software. In case that the
              installation and/or update of the Software is not part of the
              Additional Services, Customer shall ensure that it has the
              respective Software installed and updated to the then-current
              version on its computers (desktop personal computer or notebook)
              or mobile devices (e.g. iOS, Android) for the duration of the
              Additional Services.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>3.6&nbsp;</li>
        <li>
          <strong>Consequences of non-compliance </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              If Customer fails to meet its obligations under this Clause 3
              (Requirements for the provision of services; Duties and
              obligations of Customer) of Section D (Additional Services
              Specific Terms), Customer shall solely bear all the associated
              risks and losses.
              <br></br>
              <br></br>
              If Tesseract is unable to perform the Additional Services on time
              or properly for reasons attributable to the Customer (e. g. as a
              result of incorrect, incomplete or delayed provision of services
              or materials), Tesseract shall not be liable for any delays as a
              result thereof and shall be entitled to charge the resulting
              additional expenses and costs at its applicable rates.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>3.7&nbsp;</li>
        <li>
          <strong>Failure of Third-Party Service Recipient </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Should the Additional Services be carried out with a Third-Party
              Service Recipient pursuant to Clause 1.5 (Third-party service
              recipient) of Section D (Additional Services Specific Terms),
              Customer shall ensure that the Third-Party Service Recipient
              fulfils the requirements and duties set out herein above. Failure
              of Third- Party Service Recipient in compliance therewith shall be
              deemed as Customer´s own failure and the Customer shall be held
              liable in this regard.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>4&nbsp;</li>
        <li>
          <strong>Personnel; sub-contractor </strong>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>4.1&nbsp;</li>
        <li>
          <strong>Personnel </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Tesseract shall be free to choose the persons it employs to
              perform the Additional Services. Tesseract shall ensure that the
              persons employed are sufficiently qualified to perform the
              Additional Services. Tesseract shall be entitled to use
              subcontractors for the provision of Additional Services. The
              Customer acknowledges and agrees that the engagement of
              subcontractors does not necessitate prior notification or written
              consent from the Customer.{" "}
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>4.2&nbsp;</li>
        <li>
          <strong>No-hiring </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              The persons engaged by Tesseract to perform the Additional
              Services operate independently and are not subject to the
              authority of the Customer. This shall apply in particular if
              persons engaged by Tesseract perform the Additional Services on
              the Customer's premises. Both parties shall take appropriate
              measures to prevent the misclassification of Tesseract's personnel
              as Customer's employees or the hiring out of such personnel to
              third parties.
            </li>
          </ul>
        </li>
      </ul>

      <ul className="tnc-jioimmerse-wrapper-content">
        <li>5&nbsp;</li>
        <li>
          <strong>Additional Services Fees; reimbursement of expenses </strong>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>5.1&nbsp;</li>
        <li>
          <strong>Actual hourly or prepaid hourly package </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Unless otherwise explicitly stipulated in the respective order,
              the Additional Services shall either be (i) invoiced to Customer
              on a monthly or quarterly basis as may be determined by Tesseract
              and such invoice shall be remunerated on a time and material basis
              (“T&M”); or (ii) purchased as a prepaid bundled package of hours
              (“Bundled Package”).
              <br></br>
              <br></br>
              In the case of T&M, billing shall be based on the number of
              working hours performed by Tesseract. The fees payable for the
              Additional Services shall be calculated at the then current daily
              or hourly fee rates for the personnel of Tesseract as may be
              solely determined by Tesseract.
              <br></br>
              <br></br>
              In the case of Bundled Package, Customer shall have, unless a
              shorter time is provided for in the order, three hundred and
              sixty-five (365) days from the purchase date to use the hours
              contained in the Bundled Package. Any unused hours shall expire
              without any liability on Tesseract to refund the amount paid for
              such Bundled Package.
              <br></br>
              <br></br>
              In addition, Tesseract shall be entitled to reimbursement of
              expenses necessary and proven for the provision of the services,
              including but not limited to travel expenses, as provided in the
              order.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>5.2&nbsp;</li>
        <li>
          <strong>Cost Estimate </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Tesseract may quote a cost estimate for the provision of
              Additional Services in a specific project (“Cost Estimate”),
              including the applicable expenses, if any, and service fees
              calculated on the basis of a time budget estimated by Tesseract.
              Save as otherwise stipulated explicitly in the order, such time
              budget shall not imply as a complete restriction on any additional
              service fees chargeable for the Additional Services performed by
              Tesseract. In the event during the performance of Additional
              Services the quoted time budget is not sufficient for the
              completion of the project, Tesseract shall endeavour to notify
              Customer and propose a reasonable adjustment of the Cost Estimate.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>5.3&nbsp;</li>
        <li>
          <strong>Travel expenses </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              The costs for the travel, overnight stay, catering and any other
              incidental costs (“Travel Expenses”) of Tesseract’s service team
              will be charged separately to the fees payable for the Additional
              Services on actuals.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>6&nbsp;</li>
        <li>
          <strong>Intellectual Property Rights; use right </strong>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>6.1&nbsp;</li>
        <li>
          <strong>Materials </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Tesseract may use certain literary works and/or other works of
              authorship, e. g. software programs (including without limitation
              to specific or customized versions or applications of Software),
              program listings, programming tools, documentation, reports,
              databases, drawings and similar works (collectively “Materials”)
              during the provisioning of Additional Services for the purpose of
              testing, analysis, demonstrating a proof of concept or content
              development. The Additional Services does not include the transfer
              of titles or intellectual property rights in the Materials. Unless
              otherwise expressly agreed in the order between the parties, all
              ownership rights and intellectual property rights (including
              copyrights and rights of use and exploitation) in and to the
              Materials shall remain with Tesseract and/or its relevant licensor
              at all time during and after the performance of the Additional
              Services.
              <br></br>
              <br></br>
              To the extent required to provide the Additional Services,
              Tesseract grants Customer a non-exclusive, limited,
              non-transferable, non sub-licensable, revocable right to use the
              Materials for the term during which Tesseract provides the
              Additional Services to Customer. For clarity, and unless
              explicitly specified otherwise in writing, if Customer has already
              acquired an appropriate license to use the Materials, wholly or
              partly, such terms of license shall take precedence of the license
              granted under this Clause 6.1 of Section D (Additional Services
              Specific Terms) to the extent such terms of license do not
              adversely impact Tesseract's provision of Additional Services
              under this Agreement.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>6.2&nbsp;</li>
        <li>
          <strong>Work Results </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Save otherwise provided in the Agreement and the order, as between
              the parties, Tesseract is, or shall become as of creation, the
              sole and exclusive owner of any and all intellectual property
              rights, including copyrights and rights of use and exploitation,
              in the work products arising from its performance of Additional
              Services, in particular software programs (object and source code)
              and applications, content development, customization,
              configuration, implementation, settings, improvement, development
              of features, in relation to the Software, as well as other work
              products provided by Tesseract, e. g. documentation, tools,
              solutions, test results, analysis and know-how (collectively the
              “Work Results”). If and to the extent any right, title and
              interest in and to any intellectual property in Work Results are
              vested in Customer for any reason, Customer hereby assigns to
              Tesseract and Tesseract hereby accepts any such right, title and
              interest with effect as of the time of its creation. The Customer
              acknowledges and consents to this assignment. Furthermore, the
              Customer commits to execute any necessary documents and take any
              required actions to effectuate this assignment and ensure the
              proper transfer of the identified intellectual property rights to
              Tesseract. For the avoidance of doubt, Tesseract reserves the
              rights to make available any Work Results, or parts thereof, to
              third parties, e. g. Tesseract customers. To the extent legally
              possible, Customer hereby irrevocably waives and agrees never to
              assert and enforce in any manner any moral rights that it may be
              entitled to in the Software or Work Results, against Tesseract,
              any of Tesseract’s affiliates or successors in interest, or any of
              Tesseract’s, its affiliates’ or successors’ customers.
              <br></br>
              <br></br>
              To the extent required to provide the Additional Services and use
              of the Work Results by the Customer, Tesseract grants Customer a
              non-exclusive, non-transferable, non sub-licensable, revocable and
              limited right to use the Work Results for the term during which
              Tesseract provides the Additional Services to Customer. If and to
              the extent the Work Results relate to an implementation, extension
              or improvement of Customer´s use of Services, for which Customer
              has already acquired an appropriate Subscription of the License
              from Tesseract pursuant to Section B (Services Specific Terms),
              such License shall also apply to the limited use of the related
              Work Results for such implementation, extension or improvement of
              Customer´s use of Services, unless otherwise agreed by the
              parties.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>7&nbsp;</li>
        <li>
          <strong>Warranty </strong>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>7.1&nbsp;</li>
        <li>
          <strong>Warranty Period </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Tesseract warrants that it performs each Additional Services using
              reasonable care and skill of a professional service provider. Any
              claims for the breach of warranty shall be time-barred by three
              (3) months from the completion of the applicable Additional
              Services (the “Warranty Period”). If during the Warranty Period,
              Tesseract receives written notice from Customer and to the extent
              that the claimed breach is proven as existing in the performance
              of the Additional Services, Tesseract will, at its sole option,
              promptly re-perform any Additional Services that fail to meet this
              warranty or refund pro-rata the fees paid for the part of
              non-conforming Additional Services. This section sets out the sole
              and exclusive remedies available to Customer based on a breach of
              warranty above.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>7.2&nbsp;</li>
        <li>
          <strong>No commitment </strong>
          <ul className="tnc-jioimmerse-wrapper-content">
            <li>
              Except as expressly provided herein, Tesseract will not warrant or
              represent that: i) it will be able to correct all reported defects
              to the satisfaction of the Customer; or ii) the use of the
              Services, Additional Services, Hardware or any other deliverables
              will be uninterrupted or error free; or iii) the results of the
              Additional Services will meet the requirements or expectation of
              Customer, or will serve the intended use or business purposes of
              Customer. Tesseract makes no warranties regarding features or
              services provided by third parties, nor for the compatibilities of
              Services, Additional Services, and Hardware with such third-party
              software. This shall also apply even if Tesseract has been advised
              of such intended business purposes in advance.
            </li>
          </ul>
        </li>
      </ul>
      <ul className="tnc-jioimmerse-wrapper-content">
        <li>
          This Agreement along with the Order as acknowledged, confirmed and
          executed by Customer forms the entire understanding between the
          Customer and Tesseract. In the event of any conflict or inconsistency
          between the terms of the Order and this Agreement with respect to
          offering availed by you under the Order, save and except commercial
          terms stated in the Order, this Agreement shall take precedence and
          prevail over any conflicting provisions to the extent necessary to
          eliminate such conflict or inconsistency unless explicitly agreed
          otherwise between the parties in writing. No terms or conditions set
          forth on any purchase order, preprinted form or document shall add to
          or vary the terms and conditions of this Agreement, and all such terms
          or conditions shall be null and void.
        </li>
      </ul>
    </div>
  );
};

export default HorizonMasterContract;
